/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';

import Header from '../Layouts/Header';
import { lang }  from '../Helpers/lang';
import MenuSidebar from '../Layouts/MenuSidebar';
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'
import { apiUrl, cmscontentURL,mediaUrl,template1,template2,template3} from'../Config/Config';

import { GET_SETTINGDATA, GET_UPDATESETTING, GET_FONTNAME } from '../../actions';
import Select from 'react-select';
import axios from 'axios';
import { scrollToTopValidate, PageTitle,scrollToTop } from "../Helpers/SettingHelper";
import Addinputsimple from './Addinputsimple';
import CKEditor from 'ckeditor4-react';

import MyEditor from '../Helpers/MyEditor';
import MyEditor1 from '../Helpers/MyEditor1';
import MyEditor2 from '../Helpers/MyEditor2';
import MyEditor3 from '../Helpers/MyEditor3';
import MyEditor4 from '../Helpers/MyEditor4';
import { ShadowPicker } from "react-shadow-picker";

import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';

class Setting extends Component {
	
	constructor(props)
	{
		super(props);	
		this.editorRef = React.createRef();
		
		this.state = {
			settings_id:'',
			settings_site_title:'',
			settings_from_name:'',
			settings_admin_email:'',
			settings_from_email:'',
			settings_mailpath:'',
			settings_company_address:'',
			settings_commission_percentage:'',
			settings_smtp_host:'',
			settings_smtp_user:'',
			settings_smtp_pass:'',
			settings_smtp_port:'',
			settings_username:'',
			settings_mobileno:'',
			settings_email_footer:'',
			settings_commision_amount:'',
			smtp_checked:false,
			Loading: false,
			displayColorPicker: false,
			color: {
			r: '241',
			g: '112',
			b: '19',
			a: '1',
			},
			hexColor:'#f17013',
			settings_public_key:'',
			settings_product_key:'',
			settings_secret_key:'',
			stripe_live_checked:false,
			stripe_sandbox_checked:false,
			settings_embedcode:'',
			setting_goal_amount:'',
			settings_access_code:'',
			count_domain:'',
			st_position_left:'',
			st_position_right:'',
			st_position_top:'',
			st_position_bottom:'',
			pluginPositionHeight:'',
			domainSets:'',
			chat_name:'',
			letter_spacing:'',
			
			removeID:[
        	],
			fonttype : [],
			selectedFont:'',
			fontvalue:'',
			st_position_checked:true,
			st_position:'',
			supporter_additional_fee:'',
			product_layout2_checked:true,
			product_layout3_checked:false,
			google_analystic_code:'',
			category_icons_yes:true,
			category_icons_no:false,
			product_view_list:true,
			product_view_grid:false,
			dashboard_view_list:true,
			dashboard_view_grid:false,
			header_cat_limit:1,
			mainAISidebarWidth:'',
			mainAISidebarIconWidth:'',
			pluginTopSpace:'',
			pluginBottomSpace:'',
			mainAISidebarCollapsedWidth:'',
			pluginLeftSpace:'',
			pluginRightSpace:'',

			ai_fine_tune_model_id:'',
			payment_form:'normal',

			cancellation_fees_type:"flat",
			aichat_type:"text",
			cancellation_hr:'',
			cancellation_fee:'',
			reschedule_fees_type:"flat",
			reschedule_fee:'',
			reschedule_hr:'',
			np_theme:'',
			location_distance:'',
			faqmodelguest: '',
			faqmodeluser: '',
			faqmodeldoctor: '',
			faqmodelcompany:'',
			faqmodeltechnician:'',
			selectedfaqmodeluserval:'',
			selectedfaqmodelguestval:'',
			selectedfaqmodeldoctorval:'',
			selectedfaqmodelcompanyval:'',
			selectedfaqmodeltechnicianval:'',
			selectedfaqmodelguest:'',
			selectedfaqmodeldoctor:'',
			selectedfaqmodelcompany:'',
			selectedfaqmodeltechnician:'',
			selectedfaqmodeluserval:'',
			mailsend_doctor_time:'',	
			basic_consultant_fee:'',		
			consent_form_agree:'',
			dashboard_view:1,
			dashboard:'grid',
			product_view_checkbox:'show',	
			product_doctor_checkbox:'show',
			selectedinvite_discount:'',
			discountvalue:'',
			invite_discount_list : [],
			dogimage:'',
			dogimage_name: '',
			dogimage_preview: '',
			catimage:'',
			catimage_name: '',
			catimage_preview: '',
			stroke_color: '#e66465',
			invite_friend_description:'',
			invite_friend_short_description:'',
			invite_friend_heading:'',
			inviteimage_name:'',
			inviteimage_preview:'',
			inviteimage:'',
			selected_template:'',
			selected_templateval:'',
			dahboard_template:[{value:1,label:'Template 1'},{value:2,label:'Template 2'},{value:3,label:'Template 3'}],

			plugin_position_list:[{value:'fixed',label:'Fixed'},{value:'absolute',label:'Absolute'}],
			plugin_size:'600',
			plugin_radius: 1,
			company_consultant_fee:'',
			shopping_fee:'',
			display_tab:'mainTab',
			ck_description:'',

			primary_font:'',
			main_tab_font_size:'',
			menu_font_size:'',
			selectedFontVariant:'',
			st_varient_id: [],
			fontDetails: [
				
			],
			shortcut_checked: false,
			lineheight:'',
		    mobile_outer_space:false,
			shadow:"0 18px 21px 0 #0000005c",
			shadow1:"0 18px 21px 0 #0000005c",
			shadow2:"0 18px 21px 0 #0000005c",
			shadow3:"0 18px 21px 0 #0000005c",
			shadow4:"0 18px 21px 0 #0000005c",
			shadow5:"0 18px 21px 0 #0000005c",
			shadow6:"0 18px 21px 0 #0000005c",
			shadow7:"0 18px 21px 0 #0000005c",	
			shadow8:"0 18px 21px 0 #0000005c",			
			shadow9:"0 18px 21px 0 #0000005c",			
			shadow10:"0 18px 21px 0 #0000005c",			
			shadow11:"0 18px 21px 0 #0000005c",			
			shadow12:"0 18px 21px 0 #0000005c",			
			shadow13:"0 18px 21px 0 #0000005c",			
			shadow14:"0 18px 21px 0 #0000005c",			
			shadow15:"0 18px 21px 0 #0000005c",			
			shadow16:"0 18px 21px 0 #0000005c",			
			shadow17:"0 18px 21px 0 #0000005c",			
			shadow18:"0 18px 21px 0 #0000005c",	
			shadow19:"0 18px 21px 0 #0000005c",
			shadow20:"0 18px 21px 0 #0000005c",
			shadow21:"0 18px 21px 0 #0000005c",
			shadow22:"0 18px 21px 0 #0000005c",
			shadow23:"0 18px 21px 0 #0000005c",
			shortcutBoxShadowSt:false,			
			shortcutBoxShadowDet:'',
			dashboardGridShadow:'',
			ShortcutMenuShadow:'',
			ButtonShadow:'',
			PluginOpenButtonShadow:'',
			DropdownShadow:'',
			pluginMapShadow:'',
			TextareaShadow:'',
			DashboardListShadow:'',
			PluginShadow:'',
			SidemenuShadow:'',
			shadowPluginInset:'',
			lisitingShadow:'',
			shadowResult:'',
			shadowPluginInsetLeft:'',
			shadowPluginInsetTop:'',
			shadowPluginInsetRight:'',
			shadowPluginInsetBottom:'',
			shadowRightSidebar:'',
			shadowLeftSidebar:'',	

			InputBoxShadow:'',
			AIScreenTextareaShadow:'',
			openButtonInnerShadow:'',
			tableShadow:'',

			editshadow:'',
			emailimage:'',
			emailimage_name: '',
			emailimage_preview: '',
			domain_data_description:'',
			finetune_content:'',
			completion_type:'',
			DropdownRadius:'',
			pluginRadius:'',
			pluginMapRadius:'',
			TextareaRadius:'',
			lisitingRadius:'',
			InputBoxRadius:'',
			pluginOpenButtonRadius:'',
			selected_plugin_position:{value:'fixed',label:'Fixed'},
			selected_plugin_positionval:'fixed',

			selected_product_detailpage:'',
			selected_product_detailpageval:'',

			product_detailpage:[{value:'normal',label:'Left to Right Detail View'},{value:'topbottom',label:'Top to Bottom Detail View'}],
			

			themeData : [],
			selTheme  : [],
			theme_id  : '',
		};
		var qs = require('qs');
		var postobject = {
			admin_id:  localStorage.getItem("admin_id")
		};
		this.props.getSettingData(qs.stringify(postobject));
		this.props.getFontName();
		this.myCallback();
		this.onEditorChangetext = this.onEditorChangetext.bind(this);
		this.handleInputChange  = this.handleInputChange.bind(this);
		this.onEditorChange = this.onEditorChange.bind(this);
		this.onChangeHandlerDog = this.onChangeHandlerDog.bind(this);
		this.onChangeHandlerCat = this.onChangeHandlerCat.bind(this);
		this.onChangeHandlerinviteimage = this.onChangeHandlerinviteimage.bind(this);
		this.onEditorChangeinvitefrndShortDesc = this.onEditorChangeinvitefrndShortDesc.bind(this);
		this.onEditorChangeinvitefrndHead =this.onEditorChangeinvitefrndHead.bind(this);
		this.onEditorChangeinvitefrndDesc =this.onEditorChangeinvitefrndDesc.bind(this);
		this.onEditorAIChange = this.onEditorAIChange.bind( this );
		this.handleFileChange = this.handleFileChange.bind(this);
		this.handleInputShadowChange  = this.handleInputShadowChange.bind(this);
		this.onChangeHandlerEmailLogo = this.onChangeHandlerEmailLogo.bind(this);
		//this.handleClick = this.handleClick.bind(this);
					var admin_id =  localStorage.getItem("admin_id")
			axios.get(apiUrl+'thememanagement/gettheme_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					themeData: res.data.themelist
				})
			}else{
				//console.log("test")
			}
		});
    }
	// handleClick = () => {
	// 	const editorInstance = this.editorRef.current.getInstance();
	// 	editorInstance.exec('bold');
	//};
	onChangeHandlerEmailLogo=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {	
		  this.setState({
			emailimage_name: file.name,
			emailimage_preview: reader.result,
			emailimage: file
		  });
		};
		reader.readAsDataURL(file);
		const allowedExtension1 = ["png","PNG","JPG","JPEG","jpg","jpeg"];
		const fileExtension1 = file.name.split(".")[1];

		if (allowedExtension1.includes(fileExtension1)) {
			this.setState({emaillogoerror:false});
			$('.emailimage_success').html('');
		} else {
			this.setState({emaillogoerror:true});
			$('.emailimage_success').html('Incorrect file extension');
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
	}
	//  =========== font section  start ============
	handleCheckBoxChange = (e) => {
		const isChecked = e.target.checked;
		const isCheckedVal = e.target.value;
		if(isChecked){
			this.setState({ st_varient_id: [...this.state.st_varient_id, e.target.value] });
		} else{
			// setSelectedId(selectedIds.filter(id=>id !== checkedId))
			// const index = this.state.st_varient_id.indexOf(e.target.value);
			// this.state.st_varient_id.splice(index,1);
			this.setState({ st_varient_id: this.state.st_varient_id.filter(id=>id !== e.target.value) });
		}
	};
	setselectedvariants(selectvarients=null){
		
	    // const fontVariantArray = selectvarients.map((fontvar, index) => ({
	    //  id: index,
	    //  name: fontvar,
	    // }));
		// Dynamically create select list
		//let fonts = [];	
		selectvarients = (selectvarients != null ? selectvarients : {});
		if (Object.keys(selectvarients).length > 0) {	
		var listings = selectvarients.map((item, index) => {
			//fonts.push({ variant_id: item.name.id, variant_name: item.name.varient_name }),
			return (						
				<div className="form-group" key={index}>
					<input 
					onChange={this.handleCheckBoxChange.bind(this)}
					type="checkbox"  name="st_varients" 
					value={item.id}
					defaultChecked={item.isChecked}
					/>
					<span>{item.varient_name+' '+item.variant_weight}</span>
				</div>									
			);				
		});
		} else{
			var listings = '';
		}
		this.setState({selectedFontVariant : listings})
	}
	handleChangeFont = selectedFont => {
		this.setState({ selectedFont});
		this.setState({ fontvalue : selectedFont.value });
		if(selectedFont.value === ''){
		}else{
		  axios.get(apiUrl+'adminpanel/getfont_varient?font_id='+selectedFont.value)
			  .then(res => {
				  if(res.data.status == 'success'){					
					this.setselectedvariants(res.data.fontvarientlist);
				  }else{
					  this.setselectedvariants(res.data.fontvarientlist);
				  }
			  });
			 $('.errorfont').html('');
		}
	 }
	//  =========== font section  end ============
	onChangeHandlerDog=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			dogimage_name: file.name,
			dogimage_preview: reader.result,
			dogimage: file
		  });
		};
		reader.readAsDataURL(file);
		const allowedExtension1 = ["png"];
		const fileExtension1 = file.name.split(".")[1];

		if (allowedExtension1.includes(fileExtension1)) {
			this.setState({dogpngerror:false});
			$('.dogimage_success').html('');
		} else {
			this.setState({dogpngerror:true});
			$('.dogimage_success').html('Incorrect file extension');
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
	}

	onChangeHandlerCat=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			catimage_name: file.name,
			catimage_preview: reader.result,
			catimage: file
		  });
		};
		reader.readAsDataURL(file);
		const allowedExtension = ["png"];
		const fileExtension = file.name.split(".")[1];

		if (allowedExtension.includes(fileExtension)) {
			$('.catimage_success').html('');
			this.setState({catpngerror:false});
		} else {
			this.setState({catpngerror:true});
			$('.catimage_success').html('Incorrect file extension');
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
	}
	onChangeHandlerinviteimage=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		  this.setState({
			inviteimage_name: file.name,
			inviteimage_preview: reader.result,
			inviteimage: file
		  });
		};
		reader.readAsDataURL(file);
		const allowedExtension = ["png","jpg","jpeg"];
		const fileExtension = file.name.split(".")[1];

		if (allowedExtension.includes(fileExtension)) {
			$('.inviteimage_success').html('');
		} else {
			$('.inviteimage_success').html('Incorrect file extension');
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
	}
	onEditorChange( evt ) {
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				// consent_form_agree: evt.editor.getData()
			});
		},1000);     
    }
	onEditorChangeinvitefrndHead( evt ) {
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				// invite_friend_heading: evt.editor.getData()
			});
		},1000);     
    }
	onEditorChangeinvitefrndDesc( evt ) {
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				// invite_friend_description: evt.editor.getData()
			});
		},1000);     
    }
	onEditorChangeinvitefrndShortDesc(evt){
    	var callfunc = this;
    	setTimeout(function () {
			callfunc.setState( {
				// invite_friend_short_description: evt.editor.getData()
			});
		},1000);     
    }

    handleInputChange(event) {

		
		const {name, value} = event.target;      
		this.setState({
          [name]: value
        });

		if(name === 'st_position_left'){			
			this.setState({st_position_right:0});			
		}
		if(name === 'st_position_right'){			
			this.setState({st_position_left:0});			
		}
		if(name === 'st_position_top'){
			if(this.state.selected_plugin_positionval =='absolute')
			{
				this.setState({st_position_bottom:0});
			}
		}
		if(name === 'st_position_bottom'){
			if(this.state.selected_plugin_positionval =='absolute')
			{
				this.setState({st_position_top:0});
			}
		}
		if(name === 'textedit'){
			const updatedHtml = this.editorRef.current.innerHTML;
			
		}

		if(name === 'settings_mail_from_smtp'){
			this.setState({smtp_checked: !this.state.smtp_checked});
		}	
		if(name === 'settings_enable_live'){
			this.setState({stripe_live_checked: !this.state.stripe_live_checked});
			this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
		}	
		if(name === 'settings_enable_sandbox'){
			this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
			this.setState({stripe_live_checked: !this.state.stripe_live_checked});
		}	
		if(name === 'product_layout'){
			this.setState({product_layout2_checked: !this.state.product_layout2_checked});
			this.setState({product_layout3_checked: !this.state.product_layout3_checked});
		}

	  if(name === 'category_icons'){
		this.setState({category_icons_yes: !this.state.category_icons_yes});
		this.setState({category_icons_no: !this.state.category_icons_no});
     }
	 if(name === 'product_view'){
		this.setState({product_view_list: !this.state.product_view_list});
		this.setState({product_view_grid: !this.state.product_view_grid});
     }
	 if(name === 'dashboard'){
		this.setState({dashboard_view_list: !this.state.dashboard_view_list});
		this.setState({dashboard_view_grid: !this.state.dashboard_view_grid});
     }
      if(name === 'st_position'){
      	this.setState({st_position_checked: !this.state.st_position_checked});
      }
	  if(name === 'shortcut_checkbox'){
		this.setState({shortcut_checked: !this.state.shortcut_checked});
		}
		if(name  == 'mobile_outer_space'){
			this.setState({mobile_outer_space: !this.state.mobile_outer_space});
		}
    }
	
    componentDidMount() {
		var admin_id =  localStorage.getItem("admin_id")
		axios.get(apiUrl+"adminpanel/getchatmodel?admin_id="+admin_id)
			.then(res => {			
				if(res.data.status == 'success'){
					this.setState({
						faqmodelguest: res.data.faqmodelguest,
						faqmodeluser: res.data.faqmodeluser,
						faqmodeldoctor: res.data.faqmodeldoctor,
						faqmodelcompany: res.data.faqmodelcompany,
						faqmodeltechnician: res.data.faqmodeltechnician,
						all_models: res.data.all_models,
					});			
				

				}
			});

      document.title = PageTitle('Settings');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
	  let body = document.querySelectorAll("body")[0];
	if(localStorage.getItem('admin_id')){
		body.classList.remove("body-theme");
	}else{
		body.classList.add("body-theme");
	}
     }

	 componentDidUpdate(prevProps, prevState) {
		if (
		  prevState.finetune_content !== this.state.finetune_content &&
		  this.state.finetune_content
		) {
		  const editorInstance = this.editorRef.current?.getInstance();
		  if (editorInstance) {
			editorInstance.setHTML(this.state.finetune_content);
		  }
		}
	  
		if (
		  !this.state.finetune_content &&
		  prevState.domain_data_description !== this.state.domain_data_description
		) {
		  const editorInstance = this.editorRef.current?.getInstance();
		  if (editorInstance) {
			editorInstance.setHTML(this.state.domain_data_description);
		  }
		}
	  }
	 


    handleFormSubmit = () => {

		console.log('handleFormSubmit ffffffff');

			if(this.validateForm()){

				console.log('handleFormSubmit ttttt');

				this.setState({Loading:true});
				
				const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };
				  
				const formPayload = this.state;

				var qs = require('qs');
				if(this.state.smtp_checked === true){
					var settings_mail_from_smtp = '1';
				}else{
					 settings_mail_from_smtp = '0';
				}
				if(this.state.stripe_live_checked === true){
					var settings_enable_live = '1';
				}else{
					 settings_enable_live = '0';
				}

				// if(this.state.st_position_checked === true){
				// 	var plugin_position = 'fixed';
				// }else{
				// 	 plugin_position = 'absolute';
				// }

				var fonttype;
				if(formPayload.selectedFont[0]==undefined){
					fonttype = formPayload.selectedFont.value;
				}else{
					fonttype = formPayload.selectedFont[0].value;
				}

				var invitediscount;
				if(formPayload.selectedinvite_discount[0]==undefined){
					invitediscount = formPayload.selectedinvite_discount.value;
				}else{
					invitediscount = formPayload.selectedinvite_discount[0].value;
				}


				var product_layout = '';
				if(this.state.product_layout3_checked === true){
					 product_layout = '3';
				}else{
					 product_layout = '2';
				}

				var show_category = '';
				if(this.state.category_icons_yes === true){
					show_category = 'yes';
				}else{
					show_category = 'no';
				}
				var product_view = '';
				if(this.state.product_view_list === true){
					product_view = '0';
				}else{
					product_view = '1';
				}
				var dashboard = '';
				if(this.state.dashboard_view_list === true){
					dashboard = 'list';
				}else{
					dashboard = 'grid';
				} 
				if(this.state.shortcut_checked === true){
					var showshortcut = 'yes';
				}else{
					 showshortcut = 'no';
				}
				if(formPayload.mobile_outer_space ==  true){
					var enableouterspace = 'yes';
				}else{
					var enableouterspace = 'no';
				}


				
				var themeId;
				if(formPayload.selTheme[0]==undefined){
					themeId = formPayload.selTheme.value;
				}else{
					themeId = formPayload.selTheme[0].value;
				}

				// const editorInstance = this.editorRef.current.getInstance();
  				// const content = editorInstance.getMarkdown(); // Use getHTML() for HTML content


				var postObject = {
					// textedit: content,
					settings_id: formPayload.settings_id,
					settings_site_title:formPayload.settings_site_title,
					settings_from_name:formPayload.settings_from_name,
					settings_admin_email:formPayload.settings_admin_email,
					settings_from_email:formPayload.settings_from_email,
					settings_mailpath:formPayload.settings_mailpath,
					settings_company_address:formPayload.settings_company_address,
					settings_commission_percentage:formPayload.settings_commission_percentage,
					site_background: formPayload.hexColor,
					smtp_host:formPayload.settings_smtp_host,
					smtp_user:formPayload.settings_smtp_user,
					smtp_pass:formPayload.settings_smtp_pass,
					smtp_port:formPayload.settings_smtp_port,
					admin_user:formPayload.settings_username,
					admin_no:formPayload.settings_mobileno,
					settings_email_footer:formPayload.settings_email_footer,
					settings_mail_from_smtp:settings_mail_from_smtp,
					settings_public_key:formPayload.settings_public_key,
					settings_product_key:formPayload.settings_product_key,
					setting_goal_amount:formPayload.setting_goal_amount,
					supporter_additional_fee:formPayload.supporter_additional_fee,
					settings_secret_key:formPayload.settings_secret_key,
					settings_enable_live:settings_enable_live,
					st_position_left:formPayload.st_position_left,
					st_position_right:formPayload.st_position_right,
					chat_name:formPayload.chat_name,
					letter_spacing:formPayload.letter_spacing,
					st_position_top:formPayload.st_position_top,
					st_position_bottom:formPayload.st_position_bottom,
					pluginPositionHeight:formPayload.pluginPositionHeight,
					font 		  : fonttype,
					settings_commision_amount: formPayload.settings_commision_amount,
					location_distance: formPayload.location_distance,
					plugin_position: formPayload.selected_plugin_positionval,
					google_analystic_code: formPayload.google_analystic_code,
					product_layout: product_layout,
					removeId: formPayload.removeID,
					show_category_icons: show_category,
					product_view: product_view,
					header_cat_limit: formPayload.header_cat_limit,
					mainAISidebarWidth:formPayload.mainAISidebarWidth,
					mainAISidebarIconWidth:formPayload.mainAISidebarIconWidth,
					pluginTopSpace:formPayload.pluginTopSpace,
					pluginBottomSpace:formPayload.pluginBottomSpace,
					mainAISidebarCollapsedWidth:formPayload.mainAISidebarCollapsedWidth,
					pluginLeftSpace:formPayload.pluginLeftSpace,
					pluginRightSpace:formPayload.pluginRightSpace,

					ai_fine_tune_model_id: formPayload.ai_fine_tune_model_id,
					count_domain: formPayload.count_domain,
					payment_form: formPayload.payment_form,
					reschedule_fee: formPayload.reschedule_fee,
					reschedule_hr: formPayload.reschedule_hr,
					mailsend_doctor_time: formPayload.mailsend_doctor_time,
					basic_consultant_fee: formPayload.basic_consultant_fee,
					np_theme: formPayload.np_theme,
					cancellation_fee: formPayload.cancellation_fee,
					cancellation_hr: formPayload.cancellation_hr,
					cancellation_fees_type:formPayload.cancellation_fees_type,
					aichat_type:formPayload.aichat_type,
					reschedule_fees_type:formPayload.reschedule_fees_type,
					settings_faq_user_model_id:formPayload.selectedfaqmodeluserval,
					settings_faq_guest_model_id:formPayload.selectedfaqmodelguestval,
					settings_faq_doctor_model_id:formPayload.selectedfaqmodeldoctorval,
					settings_faq_company_model_id:formPayload.selectedfaqmodelcompanyval,
					settings_faq_technician_model_id:formPayload.selectedfaqmodeltechnicianval,
					consent_form_agree: formPayload.consent_form_agree,
					dashboard_view: formPayload.dashboard_view,
					dashbaord_template:formPayload.selected_templateval,

					productdetailpage :formPayload.selected_product_detailpageval,
					dashboard:dashboard,
					product_view_checkbox:formPayload.product_view_checkbox,
					product_doctor_checkbox:formPayload.product_doctor_checkbox, 
					invite_friends_discount:invitediscount,
					dogimage : formPayload.dogimage,
					catimage : formPayload.catimage,
					invite_friend_description: formPayload.invite_friend_description,
					invite_friend_short_description: formPayload.invite_friend_short_description,
					invite_friend_heading: formPayload.invite_friend_heading,
					inviteimage: formPayload.inviteimage,
					stroke_color: formPayload.stroke_color,
					company_consultant_fee: formPayload.company_consultant_fee,
					shopping_fee: formPayload.shopping_fee,
					plugin_size: formPayload.plugin_size,
					plugin_radius: formPayload.plugin_radius,
					display_tab : formPayload.display_tab,					
					primary_font:formPayload.primary_font,
					main_tab_font_size:formPayload.main_tab_font_size,
					lineheight:formPayload.lineheight,
					menu_font_size:formPayload.menu_font_size,
					st_varient_id:formPayload.st_varient_id,
					shortcut_icon: showshortcut,
					fontDetails:JSON.stringify(formPayload.fontDetails),
					enableouterspace: enableouterspace,
					chat_api_key: formPayload.chat_api_key,
					settings_task_model : formPayload.selectedallmodelvalue,

					// shortcutBoxShadowDet:formPayload.shortcutBoxShadowDet,
					// dashboardGridShadow:formPayload.dashboardGridShadow,
					// ShortcutMenuShadow:formPayload.ShortcutMenuShadow,
					// ButtonShadow:formPayload.ButtonShadow,
					// PluginOpenButtonShadow:formPayload.PluginOpenButtonShadow,
					// TextareaShadow:formPayload.TextareaShadow,
					// DashboardListShadow:formPayload.DashboardListShadow,
					// PluginShadow:formPayload.PluginShadow,
					// SidemenuShadow:formPayload.SidemenuShadow,
					// shadowPluginInset:formPayload.shadowPluginInset,
					// lisitingShadow:formPayload.lisitingShadow,

					shadowResult:formPayload.shadowResult,
					shadowPluginInsetLeft:formPayload.shadowPluginInsetLeft,
					shadowLeftSidebar:formPayload.shadowLeftSidebar,

					InputBoxShadow:formPayload.InputBoxShadow,
					AIScreenTextareaShadow:formPayload.AIScreenTextareaShadow,
					openButtonInnerShadow:formPayload.openButtonInnerShadow,
					tableShadow:formPayload.tableShadow,
					shadowRightSidebar:formPayload.shadowRightSidebar,
					shadowPluginInsetTop:formPayload.shadowPluginInsetTop,
					shadowPluginInsetRight:formPayload.shadowPluginInsetRight,
					shadowPluginInsetBottom:formPayload.shadowPluginInsetBottom,

					emailimage : formPayload.emailimage,
					// DropdownShadow:formPayload.DropdownShadow,
					// pluginMapShadow:formPayload.pluginMapShadow,
					DropdownRadius:formPayload.DropdownRadius,
					pluginRadius:formPayload.pluginRadius,
					pluginMapRadius:formPayload.pluginMapRadius,
					TextareaRadius:formPayload.TextareaRadius,
					lisitingRadius:formPayload.lisitingRadius,
					InputBoxRadius:formPayload.InputBoxRadius,
					pluginOpenButtonRadius:formPayload.pluginOpenButtonRadius,
					themeId:themeId,
				};	
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
			/* 	var domains = formPayload.domainSets
				for(let i in domains){
					formData.append('domainName[]',domains[i]['domain_name'])
				} */
				

				var domains = formPayload.domainSets;

				for(let i in domains){

					if(domains[i]['domain_id'] ==  'undefined'){
						formData.append('domainName['+ i + '][domain_id]','null')		
					}else if(domains[i]['domain_id'] !==  undefined && domains[i]['domain_id'] !==  ''){
						formData.append('domainName['+ i + '][domain_id]',domains[i]['domain_id'])
					}

					formData.append('domainName['+ i + '][domain_name]',domains[i]['domain_name'])
					formData.getAll('domainName');
				}
				this.props.getUpdateSetting(formData,config);
				////this.props.getUpdateSetting(qs.stringify(postObject));
			}
	}

	validateForm() {

		const {settings_commision_amount,location_distance,settings_id,settings_site_title,settings_from_name,settings_admin_email,settings_from_email,settings_company_address,settings_commission_percentage,settings_smtp_host,settings_smtp_user,settings_smtp_pass,settings_smtp_port,settings_username,settings_mobileno,settings_email_footer,settings_public_key,settings_product_key,setting_goal_amount,supporter_additional_fee,settings_secret_key,settings_embedcode,selectedFont,
			cancellation_fees_type,
			cancellation_hr,
			cancellation_fee,
			reschedule_fees_type,
			reschedule_fee,
			reschedule_hr,
			mailsend_doctor_time,basic_consultant_fee,consent_form_agree,chat_name,letter_spacing,selectedinvite_discount,invite_friend_description,invite_friend_short_description,invite_friend_heading,company_consultant_fee,shopping_fee,primary_font, main_tab_font_size, lineheight,menu_font_size ,st_position_checked,st_position_top,st_position_bottom,DropdownRadius,pluginRadius,pluginMapRadius,selected_plugin_positionval
		} = this.state;

		const fontDetails = [...this.state.fontDetails];
		let errors = 0;
		for (let index = 0; index < fontDetails.length; index++) {			
			if(fontDetails[index].FontType == "") {
				fontDetails[index].FontTypeCheck = "Type is required";
			  errors++;
			}else{
				fontDetails[index].FontTypeCheck = "";
			  
			}
		}

		this.setState({ fontDetails });
		if(selected_plugin_positionval =='fixed')
		{
			// console.log('errorr1818');
			if (!st_position_top) { 
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_top){		
				$('.errorsettings_st_position_top').html('');
			}
			if(!st_position_bottom) { 
				errors++;
				$('.errorsettings_st_position_bottom').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_bottom){		
				$('.errorsettings_st_position_bottom').html('');
			}			
		}else{
			$('.errorsettings_st_position_top').html('');
			$('.errorsettings_st_position_bottom').html('');
		}		

		// if (!DropdownRadius) { 
		// 	// console.log('errorr1919');
		// 	errors++;
		// 	$('.errorDropdownRadius').html('<span class="errorspan">Please fill the field</span>');
		// }else if(DropdownRadius){		
		// 	$('.errorDropdownRadius').html('');
		// }
		if (!pluginRadius) { 
			errors++;
			$('.errorpluginRadius').html('<span class="errorspan">Please fill the field</span>');
		}else if(pluginRadius){		
			$('.errorpluginRadius').html('');
		}

		if (!invite_friend_description) { 
			errors++;
			$('.error_invite_friend_description').html('<span class="errorspan">Please fill the field</span>');
		}else if(invite_friend_description){		
			$('.error_invite_friend_description').html('');
		}
	
		if (!invite_friend_heading) { 
			errors++;
			$('.error_invite_friend_heading').html('<span class="errorspan">Please fill the field</span>');
		}else if(invite_friend_heading){		
			$('.error_invite_friend_heading').html('');
		}
		if (!settings_site_title) { 
			errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_site_title){		
			$('.errorsettings_site_title').html('');
		}
		if (!settings_from_name) { 
			errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_name){
			$('.errorsettings_from_name').html('');
		}
		if (!settings_admin_email) {
			errors++; 
			$('.errorsettings_admin_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_admin_email){
			$('.errorsettings_admin_email').html('');
		}
		if (!settings_from_email) {
			errors++; 
			$('.errorsettings_from_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_email){
			$('.errorsettings_from_email').html('');
		}
		if (!settings_username) { 
			errors++;
			$('.errorsettings_username').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_username){
			$('.errorsettings_username').html('');
		}

		if (!settings_mobileno) { 
			errors++;
			$('.errorsettings_mobileno').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_mobileno){
			$('.errorsettings_mobileno').html('');
		} 


		if (!settings_commision_amount) { 
			errors++;
			$('.errorsettings_commision_amount').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_commision_amount){
			$('.errorsettings_commision_amount').html('');
		}

		if (!settings_email_footer) { 
			errors++;
			$('.errorsettings_email_footer').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_email_footer){
			$('.errorsettings_email_footer').html('');
		}

		if(!cancellation_hr) { 
			errors++;
			console.log('errorr1717');

			$('.errorsettings_cancellation_hr').html('<span class="errorspan">Please fill the field</span>');
		}else if(cancellation_hr){
			$('.errorsettings_cancellation_hr').html('');
		}

		if(!cancellation_fee) { 
			errors++;
			console.log('errorr1616');

			$('.errorsettings_cancellation_fee').html('<span class="errorspan">Please fill the field</span>');
		}else if(cancellation_fee){
			$('.errorsettings_cancellation_fee').html('');
		}

		if(!reschedule_hr) { 
			errors++;
			console.log('errorr1515');

			$('.errorsettings_reschedule_hr').html('<span class="errorspan">Please fill the field</span>');
		}else if(reschedule_hr){
			$('.errorsettings_reschedule_hr').html('');
		}
		if(!mailsend_doctor_time) { 
			errors++;
			console.log('errorr1414');

			$('.errorsettings_mailsend_doctor_time').html('<span class="errorspan">Please fill the field</span>');
		}else if(mailsend_doctor_time){
			$('.errorsettings_mailsend_doctor_time').html('');
		}
		if(!basic_consultant_fee) { 
			errors++;
			console.log('errorr1313');

			$('.errorsettings_basic_consultant_fee').html('<span class="errorspan">Please fill the field</span>');
		}else if(basic_consultant_fee){
			$('.errorsettings_basic_consultant_fee').html('');
		}
		if(!reschedule_fee) { 
			errors++;
			console.log('errorr1212');

			$('.errorsettings_reschedule_fee').html('<span class="errorspan">Please fill the field</span>');
		}else if(reschedule_fee){
			$('.errorsettings_reschedule_fee').html('');
		}
		if(!location_distance) { 
			errors++;
			console.log('errorr1111');

			$('.errorsettings_location_distance').html('<span class="errorspan">Please fill the field</span>');
		}else if(location_distance){
			$('.errorsettings_location_distance').html('');
		}
		
		if(!company_consultant_fee){
			errors++;
			console.log('errorr1010');
			$('.errorsettings_company_consultant_fee').html('<span class="errorspan">Please fill the field</span>');
		}else if(company_consultant_fee){
			$('.errorsettings_company_consultant_fee').html('');
		}

		if(!shopping_fee){
			errors++;
			console.log('errorr9999');
			$('.errorsettings_shopping_fee').html('<span class="errorspan">Please fill the field</span>');
		}else if(shopping_fee){
			$('.errorsettings_shopping_fee').html('');
		}
		/*if (!settings_company_address) {
			errors++; console.log('settings_company_address');
			$('.errorsettings_company_address').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_company_address){
			$('.errorsettings_company_address').html('');
		}*/
		// if (!settings_commission_percentage) { console.log('settings_commission_percentage');
		// 	errors++;
		// 	$('.errorsettings_commission_percentage').html('<span class="errorspan">Please fill the field</span>');
		// }else if(settings_commission_percentage){
		// 	$('.errorsettings_commission_percentage').html('');
		// }

		/*if (!settings_smtp_user) {
			errors++;
			$('.errorsettings_smtp_user').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_smtp_user){
			$('.errorsettings_smtp_user').html('');
		}

		if (!settings_smtp_pass) {
			errors++;
			$('.errorsettings_smtp_pass').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_smtp_pass){
			$('.errorsettings_smtp_pass').html('');
		}

		if (!settings_smtp_host) {
			errors++;
			$('.errorsettings_smtp_host').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_smtp_host){
			$('.errorsettings_smtp_host').html('');
		}

		if (!settings_smtp_port) {
			errors++;
			$('.errorsettings_smtp_port').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_smtp_port){
			$('.errorsettings_smtp_port').html('');
		}*/
		if (!settings_public_key) {
			errors++;
			console.log('errorr888');
			$('.errorsettings_public_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_public_key){
			$('.errorsettings_public_key').html('');
		}

		if (!settings_product_key) {
			errors++;
			console.log('errorr777');
			$('.errorsettings_product_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_product_key){
			$('.errorsettings_product_key').html('');
		}
		
		if (!settings_secret_key) {
			errors++;
			console.log('errorr666');
			$('.errorsettings_secret_key').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_secret_key){
			$('.errorsettings_secret_key').html('');
		}
		if (!consent_form_agree) {
			errors++;
			console.log('errorr555');
			$('.error_consent').html('<span class="errorspan">Please fill the field</span>');
		}else if(consent_form_agree){
			$('.error_consent').html('');
		}
		if (!chat_name) {
			errors++;
			console.log('errorr444');
			$('.errorsettings_chat_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(consent_form_agree){
			$('.errorsettings_chat_name').html('');
		}
		if (!letter_spacing) {
			errors++;
			console.log('errorr333');
			$('.errorsettings_letter_spacing').html('<span class="errorspan">Please fill the field</span>');
		}else if(consent_form_agree){
			$('.errorsettings_letter_spacing').html('');
		}
		if (!selectedinvite_discount.value) {
			errors++;
			console.log('errorr222');

			$('.errorsettings_discount').html('<span class="errorspan">Please select invite friends discount</span>');
		}else if(selectedinvite_discount.value){
			$('.errorsettings_discount').html('');
		}

		// =====font section start ==========
		if(!lineheight){
			console.log('errorr111');
			errors++;
			$('.errorlineheight').html('<span class="errorspan">Please fill the field</span>');
		}else if(lineheight){
			$('.errorlineheight').html('');
		}
			// if (!primary_font) {
			// 	errors++;
			// 	$('.errorprimary_font').html('<span class="errorspan">Please fill the field</span>');
			// }else if(primary_font){
			// 	$('.errorprimary_font').html('');
			// }
			// if (!main_tab_font_size) {
			// 	errors++;
			// 	$('.errormain_tab_font_size').html('<span class="errorspan">Please fill the field</span>');
			// }else if(main_tab_font_size){
			// 	$('.errormain_tab_font_size').html('');
			// }
			// if (!menu_font_size) {
			// 	errors++;
			// 	$('.errormenu_font_size').html('<span class="errorspan">Please fill the field</span>');
			// }else if(menu_font_size){
			// 	$('.errormenu_font_size').html('');
			// }
		// ======font section end ============	
	  console.log(errors,'errorr');
		if(errors>0) {
			setTimeout(function () {
			scrollToTopValidate();
			}, 100);
			return false;
		}else {
			return true;
		}
    }
    componentWillReceiveProps(Props){
    	if(Props.settings !== this.props.settings){			
				if(Props.settings[0].setting_font_varients.length>0)
				{
					this.setState({fontDetails:Props.settings[0].setting_font_varients});
				}else{
					this.setState({
						fontDetails: [
							{
							index: Math.random(),
							FontType: "",
							FontSize:'',
							FontWeight:'',
							letterSpacing:'',
							lineHeight:'',
							TopSpace:'',
							BottomSpace:'',
							varient_id : "",
							variants:[],
							Radius:'',
							}
						]
					});
				}
			


				

    		if(Object.keys(Props.settings).length > 0){
    			const formpayload = Props.settings[0].results;
				const themelist = Props.settings[0].themelist;
				this.setState({finetune_content:Props.settings[0].finetune_content});
				this.setState({completion_type:Props.settings[0].completion_type});
    			this.setState({settings_id:formpayload.settings_id});

				this.setState({DropdownRadius:formpayload.DropdownRadius});				
    			this.setState({pluginRadius:formpayload.pluginRadius});
    			this.setState({TextareaRadius:formpayload.TextareaRadius});
    			this.setState({lisitingRadius:formpayload.lisitingRadius});				
    			this.setState({InputBoxRadius:formpayload.InputBoxRadius});
    			this.setState({pluginOpenButtonRadius:formpayload.pluginOpenButtonRadius});
				
    			this.setState({pluginMapRadius:formpayload.pluginMapRadius});
    			this.setState({settings_site_title:formpayload.settings_site_title});
    			this.setState({settings_from_name:formpayload.settings_from_name});
    			this.setState({settings_admin_email:formpayload.settings_admin_email});
    			this.setState({settings_from_email:formpayload.settings_from_email});
    			this.setState({settings_mailpath:formpayload.settings_mailpath});
    			this.setState({settings_company_address:formpayload.settings_company_address});
    			this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
    			this.setState({settings_smtp_host:formpayload.settings_smtp_host});
    			this.setState({settings_smtp_user:formpayload.settings_smtp_user});
    			this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
    			this.setState({settings_smtp_port:formpayload.settings_smtp_port});
    			this.setState({settings_username:formpayload.settings_username});
    			this.setState({settings_mobileno:formpayload.settings_mobileno});
    			this.setState({settings_email_footer:formpayload.settings_email_footer});
    			this.setState({hexColor:formpayload.settings_site_background_color});
    			this.setState({settings_public_key:formpayload.settings_public_key});
				this.setState({settings_product_key:formpayload.settings_product_key});
				this.setState({setting_goal_amount:formpayload.setting_goal_amount});
				this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
    			this.setState({settings_secret_key:formpayload.settings_secret_key});
				this.setState({settings_embedcode:formpayload.settings_embedcode});
				this.setState({settings_access_code:formpayload.access_code});				
				this.setState({count_domain:formpayload.count_domain});				
				this.setState({st_position_left:formpayload.st_position_left});
				this.setState({st_position_right:formpayload.st_position_right});
				this.setState({chat_name:formpayload.chat_name});
				this.setState({letter_spacing:formpayload.letter_spacing});
				this.setState({st_position_top:formpayload.st_position_top});
				this.setState({st_position_bottom:formpayload.st_position_bottom});
				this.setState({pluginPositionHeight:formpayload.pluginPositionHeight});
				
				this.setState({domainSets : formpayload.domainSets});
				
				this.setState({settings_commision_amount: formpayload.settings_commision_amount});
				this.setState({location_distance: formpayload.location_distance});
				this.setState({header_cat_limit: formpayload.header_cat_limit});

				this.setState({mainAISidebarWidth: formpayload.mainAISidebarWidth});
				this.setState({mainAISidebarIconWidth: formpayload.mainAISidebarIconWidth});			

				this.setState({pluginTopSpace: formpayload.pluginTopSpace});
				this.setState({pluginBottomSpace: formpayload.pluginBottomSpace});
				this.setState({mainAISidebarCollapsedWidth: formpayload.mainAISidebarCollapsedWidth});
				this.setState({pluginLeftSpace: formpayload.pluginLeftSpace});
				this.setState({pluginRightSpace: formpayload.pluginRightSpace});

				this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});
				this.setState({payment_form: formpayload.payment_form});
				this.setState({dashboard_view: formpayload.dashboard_view});
				this.setState({dashboard: formpayload.dashboard});
				this.setState({product_view_checkbox: formpayload.product_view_checkbox});
				this.setState({product_doctor_checkbox: formpayload.product_doctor_checkbox}); 
				this.setState({consent_form_agree: formpayload.consent_form!=null?formpayload.consent_form:''});
				this.setState({reschedule_fee: formpayload.reschedule_fee});
				this.setState({reschedule_hr: formpayload.reschedule_hr});
				this.setState({mailsend_doctor_time: formpayload.mailsend_doctor_time});
				this.setState({basic_consultant_fee: formpayload.basic_consultant_fee});
				this.setState({np_theme: formpayload.notification_popup_theme});
				this.setState({cancellation_hr: formpayload.cancellation_hr});
				this.setState({cancellation_fee: formpayload.cancellation_fee});
				this.setState({cancellation_fees_type: formpayload.cancellation_fees_type});
				this.setState({aichat_type: formpayload.ai_model_type});
				this.setState({reschedule_fees_type: formpayload.reschedule_fees_type});
				this.setState({stroke_color: formpayload.canvas_stroke_clr});
				this.setState({chat_api_key: formpayload.chat_api_key})
				this.setState({company_consultant_fee: formpayload.company_consultant_fee,shopping_fee: formpayload.shopping_fee,plugin_size: formpayload.plugin_size,display_tab: formpayload.display_tab,plugin_radius: formpayload.plugin_radius});

				this.setState({primary_font:formpayload.primary_font});
				this.setState({main_tab_font_size:formpayload.main_tab_font_size});
				this.setState({lineheight:formpayload.lineheight});
				this.setState({menu_font_size:formpayload.menu_font_size});
				

				if(Props.settings[0].results.emailheaderlogo!== '' && Props.settings[0].results.emailheaderlogo!== null&& Props.settings[0].results.emailheaderlogo!== undefined){
					this.setState({emailimage_preview:mediaUrl+Props.settings[0].results.emailheaderlogo});
			    }

				if(formpayload.st_variant_id!== 'null' && formpayload.st_variant_id !== '' && formpayload.st_variant_id !== null){
					this.setState({st_varient_id:formpayload.st_variant_id});
				}

				this.setState({invite_friend_short_description: formpayload.invite_friend_short_description!=null?formpayload.invite_friend_short_description:''});
				this.setState({invite_friend_description: formpayload.invite_friend_description!=null?formpayload.invite_friend_description:''});
				this.setState({invite_friend_heading: formpayload.invite_friend_heading!=null?formpayload.invite_friend_heading:''});
				
				if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
					this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
				}
				if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
					this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
				}
				if(formpayload.settings_faq_doctor_model_id!== 'null' && formpayload.settings_faq_doctor_model_id !== ''){
					this.setState({selectedfaqmodeldoctor: {value:formpayload.settings_faq_doctor_model_id, label:formpayload.settings_faq_doctor_model_id},selectedfaqmodeldoctorval:formpayload.settings_faq_doctor_model_id});
				}
				if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
					this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
				}
				if(formpayload.settings_faq_technician_model_id!== 'null' && formpayload.settings_faq_technician_model_id !== ''){
					this.setState({selectedfaqmodeltechnician: {value:formpayload.settings_faq_technician_model_id, label:formpayload.settings_faq_technician_model_id},selectedfaqmodeltechnicianval:formpayload.settings_faq_technician_model_id });
				}
				if( formpayload.google_analystic_code !== 'null'){
					this.setState({google_analystic_code: formpayload.google_analystic_code});
				}else{
					this.setState({google_analystic_code: ''});
				}
				if(formpayload.settings_task_model!== 'null' && formpayload.settings_task_model !== ''){
					
					this.setState({selectedallmodel: {value:formpayload.settings_task_model, label:formpayload.settings_task_model},selectedallmodelvalue:formpayload.settings_task_model});
				}

				if(themelist!== '' && themelist!== null){
					this.setselectedtheme(themelist);
				}
			
				// ------------------
				this.setState({shortcutBoxShadowDet:formpayload.shortcutBoxShadowDet,shadow:formpayload.shortcutBoxShadowDet});

				this.setState({dashboardGridShadow:formpayload.dashboardGridShadow,shadow1:formpayload.dashboardGridShadow});

				this.setState({ShortcutMenuShadow:formpayload.ShortcutMenuShadow,shadow2:formpayload.ShortcutMenuShadow});
				this.setState({PluginOpenButtonShadow:formpayload.PluginOpenButtonShadow,shadow8:formpayload.PluginOpenButtonShadow});
				this.setState({DropdownShadow:formpayload.DropdownShadow,shadow9:formpayload.DropdownShadow});
				this.setState({pluginMapShadow:formpayload.pluginMapShadow,shadow11:formpayload.pluginMapShadow});				
				this.setState({ButtonShadow:formpayload.ButtonShadow,shadow3:formpayload.ButtonShadow});
				this.setState({TextareaShadow:formpayload.TextareaShadow,shadow4:formpayload.TextareaShadow});
				this.setState({DashboardListShadow:formpayload.DashboardListShadow,shadow5:formpayload.DashboardListShadow});
				this.setState({PluginShadow:formpayload.PluginShadow,shadow6:formpayload.PluginShadow});
				this.setState({SidemenuShadow:formpayload.SidemenuShadow,shadow7:formpayload.SidemenuShadow});

				this.setState({shadowPluginInset:formpayload.shadowPluginInset,shadow10:formpayload.shadowPluginInset,
				lisitingShadow:formpayload.lisitingShadow,shadow12:formpayload.lisitingShadow,					
				});

				this.setState({
				shadowResult:formpayload.shadowResult,shadow13:formpayload.shadowResult,
					shadowPluginInsetLeft:formpayload.shadowPluginInsetLeft,shadow14:formpayload.shadowPluginInsetLeft,
					shadowLeftSidebar:formpayload.shadowLeftSidebar,
					shadow18:formpayload.shadowLeftSidebar,


					shadowRightSidebar:formpayload.shadowRightSidebar,
					shadow19:formpayload.shadowRightSidebar,
					shadowPluginInsetTop:formpayload.shadowPluginInsetTop,shadow15:formpayload.shadowPluginInsetTop,
					shadowPluginInsetRight:formpayload.shadowPluginInsetRight,shadow16:formpayload.shadowPluginInsetRight,
					shadowPluginInsetBottom:formpayload.shadowPluginInsetBottom,shadow17:formpayload.shadowPluginInsetBottom,
					InputBoxShadow:formpayload.InputBoxShadow,
					AIScreenTextareaShadow:formpayload.AIScreenTextareaShadow,
					openButtonInnerShadow:formpayload.openButtonInnerShadow,
					shadow20:formpayload.InputBoxShadow,
					shadow21:formpayload.AIScreenTextareaShadow,
					shadow22:formpayload.openButtonInnerShadow,
					tableShadow:formpayload.tableShadow,shadow23:formpayload.tableShadow,

					
				});
				
			

    			if(formpayload.settings_mail_from_smtp === '1'){
    				this.setState({smtp_checked: true});
    			}else{
    				this.setState({smtp_checked: false});
    			}

    			if(formpayload.enable_live === '1'){
    				this.setState({stripe_live_checked: true,stripe_sandbox_checked:false });
    			}else{
    				this.setState({stripe_sandbox_checked: true,stripe_live_checked:false});
    			}

    			if(formpayload.st_plugin_position === 'fixed'){
    				this.setState({selected_plugin_position: {value:'fixed',label:'Fixed'} ,selected_plugin_positionval:'fixed'});
    			}else{
    				// this.setState({st_position_checked: false});
					this.setState({selected_plugin_position: {value:'absolute',label:'Absolute'} ,selected_plugin_positionval:'absolute'});
    			}

    			if(formpayload.product_layout === '2'){
    				this.setState({product_layout2_checked: true });
    				this.setState({product_layout3_checked: false});
    			}else{
    				this.setState({product_layout3_checked: true});
    				this.setState({product_layout2_checked: false });
    			}

				if(formpayload.show_category_icons === 'yes'){
    				this.setState({category_icons_yes: true });
    				this.setState({category_icons_no: false});
    			}else{
    				this.setState({category_icons_no: true});
    				this.setState({category_icons_yes: false });
    			}
				if(formpayload.product_view === "0"){
    				this.setState({product_view_list: true });
    				this.setState({product_view_grid: false});
    			}else{
    				this.setState({product_view_grid: true});
    				this.setState({product_view_list: false });
    			}

				if(formpayload.dashboard === "list"){
    				this.setState({dashboard_view_list: true });
    				this.setState({dashboard_view_grid: false});
    			}else{
    				this.setState({dashboard_view_grid: true});
    				this.setState({dashboard_view_list: false });
    			}

				if(formpayload.dashbaord_template == 1){
    				this.setState({selected_templateval:1,selected_template:{value:1,label:'Template 1'} });
    			}else if(formpayload.dashbaord_template == 2){
    				this.setState({selected_templateval:2,selected_template:{value:1,label:'Template 2'} });
    			}else{
					this.setState({selected_templateval:3,selected_template:{value:1,label:'Template 3'} });
				}

				if(formpayload.productdetailpage == 'normal'){
    				this.setState({selected_product_detailpageval:'normal',selected_product_detailpage:{value:'normal',label:'Left to Right Detail View'} });
    			}else if(formpayload.productdetailpage == 'topbottom'){
    				this.setState({selected_product_detailpageval:'topbottom',selected_product_detailpage:{value:'topbottom',label:'Top to Bottom Detail View'} });
    			}

				if(formpayload.shortcut_icon === 'yes'){
    				this.setState({shortcut_checked: true });
    			}else{
    				this.setState({shortcut_checked: false});
    			}
				if(formpayload.mobile_plugin_outer_space === 'yes'){
    				this.setState({mobile_outer_space: true });
    			}else{
    				this.setState({mobile_outer_space: false});
    			}

			    if(Props.settings[0].font!== '' && Props.settings[0].font!== null){
			        this.setselectedvalue(Props.settings[0].font);
			    }

				if(Props.settings[0].fontvarientlist!== '' && Props.settings[0].fontvarientlist!== null){
					this.setselectedvariants(Props.settings[0].fontvarientlist);
				}

				if(Props.settings[0].invite_friends_discount!== '' && Props.settings[0].invite_friends_discount!== null){
					this.setState({selectedinvite_discount:{ value: Props.settings[0].results.invite_friends_discount, label: Props.settings[0].results.invite_friends_discount }});
			    }

				if(Props.settings[0].discountlist!== '' && Props.settings[0].discountlist!== null){
					this.setState({invite_discount_list:Props.settings[0].discountlist});
			    }
				if(Props.settings[0].results.catcanvas_image!== '' && Props.settings[0].results.catcanvas_image!== null){
					this.setState({catimage_preview:mediaUrl+Props.settings[0].results.catcanvas_image});
			    }
				if(Props.settings[0].results.dogcanvas_image!== '' && Props.settings[0].results.dogcanvas_image!== null){
					this.setState({dogimage_preview:mediaUrl+Props.settings[0].results.dogcanvas_image});
			    }
				if(Props.settings[0].results.inviteimage!== '' && Props.settings[0].results.inviteimage!== null){
					this.setState({inviteimage_preview:mediaUrl+Props.settings[0].results.inviteimage});
			    }


				


    		}
    	}
    	  	if(Props.updatesetting !== this.props.updatesetting){ 
			
    		if(Object.keys(Props.updatesetting).length > 0){

				if(Props.updatesetting[0].status=='catcanvaserror'){

					$('.catimage_success').html(Props.updatesetting[0].message);
						// setTimeout(
						// function() {
						// 	$('.female_image_success').html('');
						// }
						// .bind(this),
						// 3000
						// );
				}else if(Props.updatesetting[0].status=='dogcanvaserror'){
					$('.dogimage_success').html(Props.updatesetting[0].message);
						// setTimeout(
						// function() {
						// 	$('.image_success').html('');
						// }
						// .bind(this),
						// 3000
						// );
				}else if(Props.updatesetting[0].status=='mailheadererror'){
					$('.emailimage_success').html(Props.updatesetting[0].message);
						// setTimeout(
						// function() {
						// 	$('.image_success').html('');
						// }
						// .bind(this),
						// 3000
						// );
				}else{	
					this.setState({ Loading: false });
					const formpayload = Props.updatesetting[0].results;					
					$('.success_message').html('<div class="status_sucess"><h3>'+ Props.updatesetting[0].message+'</h3></div>');
					this.setState({fontDetails:Props.updatesetting[0].setting_font_varients});
					this.setState({settings_id:formpayload.settings_id});
					
					this.setState({DropdownRadius:formpayload.DropdownRadius});
    				this.setState({pluginRadius:formpayload.pluginRadius});
					this.setState({pluginMapRadius:formpayload.pluginMapRadius});

					this.setState({TextareaRadius:formpayload.TextareaRadius});
					this.setState({lisitingRadius:formpayload.lisitingRadius});		
					this.setState({InputBoxRadius:formpayload.InputBoxRadius});
					this.setState({pluginOpenButtonRadius:formpayload.pluginOpenButtonRadius});

					this.setState({settings_site_title:formpayload.settings_site_title});
					this.setState({settings_from_name:formpayload.settings_from_name});
					this.setState({settings_admin_email:formpayload.settings_admin_email});
					this.setState({settings_from_email:formpayload.settings_from_email});
					this.setState({settings_mailpath:formpayload.settings_mailpath});
					this.setState({settings_company_address:formpayload.settings_company_address});
					this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
					this.setState({settings_smtp_host:formpayload.settings_smtp_host});
					this.setState({settings_smtp_user:formpayload.settings_smtp_user});
					this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
					this.setState({settings_smtp_port:formpayload.settings_smtp_port});
					this.setState({settings_username:formpayload.settings_username});
					this.setState({settings_mobileno:formpayload.settings_mobileno});
					this.setState({settings_email_footer:formpayload.settings_email_footer});
					this.setState({hexColor:formpayload.settings_site_background_color});
					this.setState({settings_public_key:formpayload.settings_public_key});
					this.setState({settings_product_key:formpayload.settings_product_key});
					this.setState({setting_goal_amount:formpayload.setting_goal_amount});
					this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
					this.setState({settings_secret_key:formpayload.settings_secret_key});
					this.setState({settings_embedcode:formpayload.settings_embedcode});
					this.setState({settings_access_code:formpayload.access_code});
					this.setState({count_domain:formpayload.count_domain});
					this.setState({st_position_left:formpayload.st_position_left});
					this.setState({st_position_right:formpayload.st_position_right});
					this.setState({st_position_top:formpayload.st_position_top});
					this.setState({st_position_bottom:formpayload.st_position_bottom});
					this.setState({pluginPositionHeight:formpayload.pluginPositionHeight});					
					this.setState({domainSets: formpayload.domainSets});
					this.setState({settings_commision_amount: formpayload.settings_commision_amount});
					this.setState({location_distance: formpayload.location_distance});
					this.setState({header_cat_limit: formpayload.header_cat_limit});

					this.setState({mainAISidebarWidth: formpayload.mainAISidebarWidth});
					this.setState({mainAISidebarIconWidth: formpayload.mainAISidebarIconWidth});
					this.setState({pluginTopSpace: formpayload.pluginTopSpace});
					this.setState({pluginBottomSpace: formpayload.pluginBottomSpace});
					this.setState({mainAISidebarCollapsedWidth: formpayload.mainAISidebarCollapsedWidth});
					this.setState({pluginLeftSpace: formpayload.pluginLeftSpace});
					this.setState({pluginRightSpace: formpayload.pluginRightSpace});

					

					this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});
					this.setState({chat_name: formpayload.chat_name});
					this.setState({letter_spacing: formpayload.letter_spacing});	
					this.setState({stroke_color: formpayload.canvas_stroke_clr});			
					this.setState({np_theme: formpayload.notification_popup_theme});

					this.setState({primary_font:formpayload.primary_font});
					this.setState({main_tab_font_size:formpayload.main_tab_font_size});
					this.setState({lineheight:formpayload.lineheight});			
					this.setState({menu_font_size:formpayload.menu_font_size});
					
					this.setState({company_consultant_fee: formpayload.company_consultant_fee,shopping_fee: formpayload.shopping_fee,plugin_size: formpayload.plugin_size,plugin_radius: formpayload.plugin_radius});

					if( formpayload.google_analystic_code !== 'null'){
						this.setState({google_analystic_code: formpayload.google_analystic_code});
					}else{
						this.setState({google_analystic_code: ''});
					}

					if(formpayload.settings_mail_from_smtp === '1'){
						this.setState({smtp_checked: true});
					}else{
						this.setState({smtp_checked: false});
					}


					if(formpayload.st_plugin_position === 'fixed'){
						this.setState({st_position_checked: true });
					}else{
						this.setState({st_position_checked: false});
					}

					if(formpayload.product_layout === '2'){
						this.setState({product_layout2_checked: true });
						this.setState({product_layout3_checked: false});
					}else{
						this.setState({product_layout3_checked: true});
						this.setState({product_layout2_checked: false });
					}

					if(formpayload.enable_live === '1'){
						this.setState({stripe_checked: true});
					}else{
						this.setState({stripe_checked: false});
					}

					if(formpayload.show_category_icons === 'yes'){
						this.setState({category_icons_yes: true });
						this.setState({category_icons_no: false});
					}else{
						this.setState({category_icons_no: true});
						this.setState({category_icons_yes: false });
					}
					if(formpayload.product_view === "0"){
						this.setState({product_view_list: true });
						this.setState({product_view_grid: false});
					}else{
						this.setState({product_view_grid: true});
						this.setState({product_view_list: false });
					}
    				scrollToTop();

    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
				}
    		}
    	}
    	/*if(Props.fontname !== this.props.fontname){
    		if(Object.keys(Props.fontname).length > 0){
    		    this.setState({ fonttype : Props.fontname[0].fontlist})

    		}
    	}*/

    	var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id)
			
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						fonttype: res.data.fontlist
					})
				
				}else{
				//console.log("test")
				}
			});

	}

	setselectedvalue(selectsers){
		
	//     const fontArray = selectsers.map((fonttype, index) => ({
	//      id: index,
	//      name: fonttype,
	//     }));
    // // Dynamically create select list
    // let fonts = [];
    // fontArray.map(item =>
    // fonts.push({ label: item.name.label, value: item.name.value }),
    // );
    // this.setState({selectedFont : fonts})
  }

  	setselecteddiscount(selectsers){
		const fontArray = selectsers.map((fonttype, index) => ({
		id: index,
		name: fonttype,
		}));
		// Dynamically create select list
		let fonts = [];
		fontArray.map(item =>
		fonts.push({ label: item.name.label, value: item.name.value }),
		);
		this.setState({selectedFont : fonts})
	}


	handleClick = () => {
	this.setState({ displayColorPicker: !this.state.displayColorPicker })
	};

	handleClose = () => {
	this.setState({ displayColorPicker: false })
	};

	handleChange = (color) => {
	this.setState({hexColor : color.hex})
	this.setState({ color: color.rgb })
	};

	 copyCodeToClipboard(event){
		event.preventDefault;
		const el = this.textArea
		el.select()
		document.execCommand("copy")
   }


   writeText = () => {
	 
	$('.copied_title').html('<span class=""><h3>Copied</h3></span>');

	//onClick={() =>  navigator.clipboard.writeText(tester)}
	let test1 = this.state.settings_access_code;
	
	let  tester =	'<script src="https://runadmin.UXT.design/plugin.js"></script> <div data-client="'+test1+'"  id="pet_container"></div>';
	 navigator.clipboard.writeText(tester);
	setTimeout(
		function() {
			$('.copied_title').html('');
			$('.copied_title').hide();
		}
		.bind(this),
		3000
		);
		
    }

/*    myCallback = (domainsets) => {
   	//console.log(domainsets,'domainsets')
    this.setState({domainSets: domainsets});
  }; */

  myCallback = (domainsets,domainID,domain_count) => {

    this.setState({domainSets: domainsets,removeID: domainID,domain_count:domain_count});
   };


//    handleChangeFont = selectedFont => {
//       this.setState({ selectedFont});
//       this.setState({ fontvalue : selectedFont.value });
//       if(selectedFont.value === ''){
//         //$('.errorfont').html('<span class="errorspan">Please select the font</span>');
//       }else{
//       	 $('.errorfont').html('');
//       }
//    }
    handleChangeDiscount = selectedinvite_discount => {
	this.setState({ selectedinvite_discount});
	this.setState({ discountvalue : selectedinvite_discount.value });
	if(selectedinvite_discount.value === ''){
	  
	}else{
		$('.errorsettings_discount').html('');
	}
 }
   	handleChangeAimodeluser = selectedfaqmodeluser => {
		this.setState({ selectedfaqmodeluser});
		this.setState({ selectedfaqmodeluserval : selectedfaqmodeluser.value });	
 	}

	handleChangeAimodelguest = selectedfaqmodelguest => {
		this.setState({ selectedfaqmodelguest});
		this.setState({ selectedfaqmodelguestval : selectedfaqmodelguest.value });	
	}

	handleChangeAimodeldoctor = selectedfaqmodeldoctor => {
		this.setState({ selectedfaqmodeldoctor});
		this.setState({ selectedfaqmodeldoctorval : selectedfaqmodeldoctor.value });	
	}

	handleChangeAimodelcompany = selectedfaqmodelcompany => {
		this.setState({ selectedfaqmodelcompany});
		this.setState({ selectedfaqmodelcompanyval : selectedfaqmodelcompany.value });	
	}

	handleChangeAimodeltechnician = selectedfaqmodeltechnician => {
		this.setState({ selectedfaqmodeltechnician});
		this.setState({ selectedfaqmodeltechnicianval : selectedfaqmodeltechnician.value });	
	}

	handleChangeDahboardTemplate = selected_template =>{
		this.setState({ selected_template});
		this.setState({ selected_templateval : selected_template.value });
	}

	handleChangeproductdetailpage = selected_product_detailpage =>{
		this.setState({ selected_product_detailpage});
		this.setState({ selected_product_detailpageval : selected_product_detailpage.value });
	}

	handleChangeplugin_position = selected_plugin_position =>{
		this.setState({ selected_plugin_position});
		this.setState({ selected_plugin_positionval : selected_plugin_position.value });
	}		
	showTemplatePopup = ()=>{
		$('.template-popup').addClass('show');
	}
	closeTemplatePopup  = ()=>{
		$('.template-popup').removeClass('show');
	}

	onEditorAIChange( evt ) {
		console.log(evt,'evt')
		var callfunc = this;
		setTimeout(function(){
			this.setState( {domain_data_description:evt},()=>{
			});
		}.bind(this),1000);
	}

	
	

// 	handleSave = () => {
// 		this.setState({Loading:true});
// 		const config = {
// 			headers: {
// 			  'Content-Type': 'multipart/form-data'
// 			}
// 		  };
// 		const formPayload = this.state;
// 		var qs = require('qs');
// 		var postObject = {
			
// 			settings_id: formPayload.settings_id,
// 			admin_id: localStorage.getItem('admin_id'),
// 			aifeed:this.state.domain_data_description,
// 			type : formPayload.type,
// 			imp_cate : 7
			
// 		};

// 		let formData = new FormData();
// 		for(let k in postObject) {
// 		formData.append(k, postObject[k]);
// 		}
	
		
		

// 		axios.post(apiUrl+"faq/settingaifeedsave",formData,config).then(res => {
// 			if(res.data.results){
// 				// this.setState({Loading:false});
// 				// 		const formpayload = res.data.results;
// 				// 		$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
// 				// 		this.setState({settings_id:formpayload.settings_id});
// 				// 		scrollToTop();
// 				// 		setTimeout(
// 				// 			function() {
// 				// 				$('.success_message').html('');
// 				// 			}
// 				// 			.bind(this),
// 				// 			3000
// 				// 			);
// 			}
				 
// 		 }); 
	
// }

// ================================font start ====================
addFunc = e => {
	this.setState(prevState => ({
	  fontDetails: [
		...prevState.fontDetails,
		{
		  index: Math.random(),
		  FontType: "",
		  FontSize:'',
		  FontWeight:'',
		  letterSpacing:'',
		  lineHeight:'',
		  TopSpace:'',
		  BottomSpace:'',
		  varient_id : "",
		  variants:[],
		  Radius:'',
		}
	  ]
	}));
};
deleteFunc(record) {
	this.setState({
	  fontDetails: this.state.fontDetails.filter(r => r !== record)
	});
}
Capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
}
addMoreFunc = (e) => {	
	return this.state.fontDetails.map((val, idx) => {
		
		let FontType = `FontType${idx}`,
		FontWeight = `FontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		errorfile = `errorfile${idx}`;
		return ( <>
		  <div className="form-row mb-0" key={val.index}>
		  		<div className='form-left'>			
				<div className="form-group"  >					
					<label className='pb-0'>
						{/* Apply font : */}

						{/* Font Apply to { val.FontType=='lgbutton'?"Large Button" : val.FontType=='smbutton' ? 'Small Button': this.Capitalize(val.FontType)} */}
						
						Font Apply to {val.FontType=='MenuIcon'?'Menu Icon':''}
						{val.FontType=='mainTab'?'Main Tab':''}
						{val.FontType=='sideMenu'?'Side Menu':''}
						{val.FontType=='subTitle'?'Sub Title':''}
						{val.FontType=='lgbutton'?'Large Button':''}
						{val.FontType=='listFont'?'List Font':''}
						{val.FontType=='listTitleFont'?'List Title Font':''}
						{val.FontType=='listSerialNoFont'?'List Serial No Font':''}

						{val.FontType=='mainAIChatTitle'?'Main AI Chat Title':''}
						{val.FontType=='mainAIChat'?'Main AI Chat':''}
						{val.FontType=='mainAIChatSummaryTitle'?'Main AI Chat Summary Title':''}
						{val.FontType=='mainAIChatSummary'?'Main AI Chat Summary':''}
						{val.FontType=='mainAIProfile'?'Main AI Profile':''}	

						{(val.FontType!='listSerialNoFont'&& 
							val.FontType!='listTitleFont'&&
							val.FontType!='MenuIcon'&&
							val.FontType!='mainTab'&&
							val.FontType!='sideMenu'&&
							val.FontType!='subTitle'&&
							val.FontType!='lgbutton'&&
							val.FontType!='listFont'&&

							val.FontType!='mainAIChatTitle'&&
							val.FontType!='mainAIChat'&&
							val.FontType!='mainAIChatSummaryTitle'&&
							val.FontType!='mainAIChatSummary'&&
							val.FontType!='mainAIProfile'&&

							val.FontType!='listTitleFont')?this.Capitalize(val.FontType):''}

						
						</label>	
					{/* <div className='d-flex align-items-center gap-3'>					
					<select name="FontType" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
						<option value="" className="fontVarientName" > Select Type</option>
						<option value="PrimaryFont" className="fontVarientName" selected={val.FontType=='PrimaryFont'?true:false} > Primary Font</option>
						<option value="mainTab" className="fontVarientName" selected={val.FontType=='mainTab'?true:false} > MainTab</option>
						<option value="sideMenu" className="fontVarientName" selected={val.FontType=='sideMenu'?true:false} > SideMenu</option>
						<option value="title" className="fontVarientName" selected={val.FontType=='title'?true:false} > Title</option>
						<option value="subTitle" className="fontVarientName" selected={val.FontType=='subTitle'?true:false}> SubTitle</option>
						<option value="button" className="fontVarientName"selected={val.FontType=='button'?true:false} > Button</option>
						<option value="smButton" className="fontVarientName" selected={val.FontType=='smButton'?true:false}> SmallButton</option>
						<option value="lgButton" className="fontVarientName" selected={val.FontType=='lgButton'?true:false}> LargeButton</option>										
					</select>						
					{idx === 0 ? (
					<span className="add_font_varients cursor-pointer"  onClick={() => this.addFunc()}><i class="fa fa-plus-circle fa-1x"></i></span> ) : 
					<span className="btn_remove cursor-pointer" onClick={() => this.deleteFunc(val)} ><i class="fa fa-trash fa-1x"></i></span>
					}	
					</div>	 */}
					<div className='mt-2'>{val.FontTypeCheck}</div>				
				</div>
				</div>
			</div>
			<div className="form-row" key={val.index}>	
				{this.varientField(val.FontType,idx,val)}
		  	</div>
		  </>
		);
	  });
}
varientField = (FontType,idx,val)=>{

	//load tthe fonts for options

	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value,type:item.name.type }),
	);
	let FontWeight = `FontWeight${idx}`,
		FontSize = `FontSize${idx}`,
		letterSpacing = `letterSpacing${idx}`,
		lineHeight = `lineHeight${idx}`,
		TopSpace = `TopSpace${idx}`,
		Radius = `Radius${idx}`,
		BottomSpace = `BottomSpace${idx}`,
		FontFamily = `FontFamily${idx}`,
		errorfile = `errorfile${idx}`
		
		return(
			<>
			<div className="form-left">
				<div className="form-group">
						<label>Family:</label>
						{/* <Select  name="font_family"
							id={FontFamily} data-id={idx} onChange={(e) => this.handleFontFamilyChange(e, idx)}  
							options={fonts}  
							value={val.font_family?val.font_family:{ value: '0', label: 'Select Font Family' }}
							placeholder="Select Font Family" /> */}

							<select name="font_family" className="form-control" id={FontFamily} data-id={idx} onChange={(e) => this.handleFontFamilyChange(e, idx)}>

								{/* <option value="" className="fontFamilyId" > Select Font Family</option>						
								{fonts.map((option) => (
								<option key={option.value} value={option.value}  selected={val.font_family==option.value?true:false}>
									{option.label}
								</option> ))} */}
								
  <option value="">Select Font</option>

<optgroup label="System Fonts">
  {fonts
	.filter(f => f.type === 'system_font')
	.map(option => (
	  <option key={option.value} value={option.value} selected={val.font_family==option.value?true:false}>
		{option.label}
	  </option>
	))}
</optgroup>

<optgroup label="Google Fonts">
  {fonts
	.filter(f => f.type === 'google_font')
	.map(option => (
	  <option key={option.value} value={option.value} selected={val.font_family==option.value?true:false}>
		{option.label}
	  </option>
	))}
</optgroup>
<optgroup label="Custom Fonts">
  {fonts
	.filter(f => f.type === 'normal_font')
	.map(option => (
	  <option key={option.value} value={option.value} selected={val.font_family==option.value?true:false}>
		{option.label}
	  </option>
	))}
</optgroup>

							
							</select> 
						<div className="errorfamily"></div>
					</div>
				<div className="form-group">
					<label>Font Size  :</label>
					<div>
						<input type="text" name="FontSize" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.FontSize}
						data-id={idx}
						id={FontSize}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	

				{(FontType =='lgbutton' || FontType=='smbutton' || FontType=='Open Button')&&
				<>			
				<div className="form-group">
					<label>Top Space :</label>
					<div>
						<input type="text" name="TopSpace" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						value={val.TopSpace}
						data-id={idx}
						id={TopSpace}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>				
				<div className="form-group">
					<label>Radius :</label>
					<div>
						<input type="text" name="Radius" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						value={val.Radius}
						data-id={idx}
						id={Radius}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	</>
				}
			
				
				
			</div>
			<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
						<select name="FontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

						{this.state.fontDetails[idx].variants!=undefined?
						<>{this.state.fontDetails[idx]?.variants?.map((variant) => (
							<option 
								key={variant.value} 
								value={variant.value || val.fontWeight} 
								selected={val.fontWeight == variant.value ? true : false}
							>
								{variant.label} {variant.value}
							</option>
						))} </>
						:<><option value="" className="fontVarientName" > Select Variant</option>
						{/* // <option value="200" className="fontVarientName" selected={val.FontWeight=='200'?true:false} > Extra Light200</option>
						//<option value="300" className="fontVarientName" selected={val.FontWeight=='300'?true:false}> Light 300</option> * */}
						<option value="400" className="fontVarientName" selected={val.FontWeight=='400'?true:false}> Regular 400</option>
						<option value="500" className="fontVarientName" selected={val.FontWeight=='500'?true:false}> Medium 500</option>
						<option value="600" className="fontVarientName" selected={val.FontWeight=='600'?true:false} > Semi Bold 600</option>
						<option value="700" className="fontVarientName" selected={val.FontWeight=='700'?true:false}> Bold 700</option>
						<option value="800" className="fontVarientName" selected={val.FontWeight=='800'?true:false}> Extra Bold 800</option>
						<option value="900" className="fontVarientName" selected={val.FontWeight=='900'?true:false}>Black 900</option> 
						</>}
								
										
						</select>	


									
						<div className={errorfile}></div> 
					</div>
				</div>	

				<div className="form-group">
					<label>Letter Spacing :</label>
					<div>
						<input type="text" name="letterSpacing" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						//onChange={this.onFileChange}
						value={val.letterSpacing}
						data-id={idx}
						id={letterSpacing}    /> 
									
						<div className={errorfile}></div> 
					</div>
				</div>	
				{(FontType =='lgbutton' || FontType=='smbutton' || FontType=='Open Button')&&
				<div className="form-group">
					<label>Bottom Space :</label>
					<div>
						<input type="text" name="BottomSpace" 
						onChange={(e) => this.handleFileChange(e, idx)} 
						value={val.BottomSpace}
						data-id={idx}
						id={BottomSpace}    /> 									
						<div className={errorfile}></div> 
					</div>
				</div>	}

			</div>	
			</>);

}
handleFontFamilyChange = (e, idx) => {
	let fontDetails = [...this.state.fontDetails];
	fontDetails[idx]['varient_id'] = idx;	
	fontDetails[idx]['font_family'] = e.target.value;	
	// if (fontValue) {
		try {

			axios.get(apiUrl+'font/getvarientlistdetail?id='+e.target.value)
			.then(res => {
				if(res.data.status == 'success'){		
					if(res.data.variants.length>1)	
						{
							fontDetails[idx] = { 
								...fontDetails[idx], 
								variants: res.data.variants  
							};
						}else{
							fontDetails[idx] = { 
								...fontDetails[idx], 
								variants: [{value: "", label: "Varient not found"}]
							};
						}		
					
					
					this.setState({
						fontDetails: 			  
						fontDetails
					});
				}
				// else{
				// 	this.setselectedvariants(res.data.fontvarientlist);
				// }
			});

			// const response = axios.get(`${apiUrl}font/getvarientlistdetail`, {
			// 	params: {
			// 		id: e.target.value  
					
			// 	}
			// });
			// if (response.data.variants) {
			// 	fontDetails[idx] = { 
			// 		...fontDetails[idx], 
			// 		variants: response.data.variants  
			// 	};
			// 	console.log(response.data.variants,'this is fortvarientrecords')
			// }
		} catch (error) {
			console.error("Error fetching font variants:", error);
		}
	// }
	// this.setState({
	// 	fontDetails: 			  
	// 	fontDetails
	// });

	
}; 

handleFileChange = (e, idx) => {
	let	font_file = `font_file${idx}`;
	let fontDetails = [...this.state.fontDetails];
	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
	

	this.setState({
			fontDetails: 			  
			  fontDetails
		  });

}; 
handleChangeAllmodelguest = selectedallmodel => {
	this.setState({ selectedallmodel});
	this.setState({ selectedallmodelvalue : selectedallmodel.value });	
}
// ================================font end ====================

boxShadowFunc = (name) =>{
	//$('.input-popup-action').addClass('show');		
	this.setState({shortcutBoxShadowSt: !this.state.shortcutBoxShadowSt,editshadow:name})
}
saveboxShadowFunc = () =>{	
	this.setState({shortcutBoxShadowSt: !this.state.shortcutBoxShadowSt, shortcutBoxShadowDet: this.state.shadow,editshadow:''});

	// this.setState({shortcutBoxShadowSt: !this.state.shortcutBoxShadowSt, shortcutBoxShadowDet: this.state.shadow,});

}
handleInputShadowChange(event) {
	const {name, value} = event.target;      
	this.setState({
		[name]: value
	});
	if(name === 'shortcutBoxShadowDet'){
		this.setState({shadow: value});
	}if(name === 'dashboardGridShadow'){
		this.setState({shadow1: value});
	}
	if(name === 'ShortcutMenuShadow'){
		this.setState({shadow2: value});
	}
	if(name === 'ButtonShadow'){
		this.setState({shadow3: value});
	}
	if(name === 'PluginOpenButtonShadow'){
		this.setState({shadow8: value});
	}
	if(name === 'DropdownShadow'){
		this.setState({shadow9: value});
	}
	if(name === 'pluginMapShadow'){
		this.setState({shadow11: value});
	}
	
	if(name === 'TextareaShadow'){
		this.setState({shadow4: value});
	}
	if(name === 'DashboardListShadow'){
		this.setState({shadow5: value});
	}
	if(name === 'PluginShadow'){
		this.setState({shadow6: value});
	}
	if(name === 'SidemenuShadow'){
		this.setState({shadow7: value});
	}
	if(name === 'shadowPluginInset'){
		this.setState({shadow10: value});
	}
	if(name === 'lisitingShadow'){
		this.setState({shadow12: value});
	}	
	
	if(name === 'shadowResult'){
		this.setState({shadow13: value});
	}
	
	if(name === 'shadowRightSidebar'){
		this.setState({shadow19: value});
	}
	if(name === 'shadowLeftSidebar'){
		this.setState({shadow18: value});
	}if(name === 'shadowPluginInsetLeft'){
		this.setState({shadow14: value});
	}if(name === 'shadowPluginInsetTop'){
		this.setState({shadow15: value});
	}if(name === 'shadowPluginInsetRight'){
		this.setState({shadow16: value});
	}if(name === 'shadowPluginInsetBottom'){
		this.setState({shadow17: value});
	}
	if(name === 'InputBoxShadow'){
		this.setState({shadow20: value});
	}if(name === 'AIScreenTextareaShadow'){
		this.setState({shadow21: value});
	}if(name === 'openButtonInnerShadow'){
		this.setState({shadow22: value});
	}
	if(name === 'tableShadow'){
		this.setState({shadow23: value});
	}

	
	


}
shadowchange=(value) => {
	var name = this.state.editshadow;
	// const {name, value} = event.target;      
	// this.setState({[name]: value });
	if(name === 'shortcutBoxShadowDet'){
		this.setState({shadow: value,shortcutBoxShadowDet:value});
	}	
	if(name === 'dashboardGridShadow'){
		this.setState({shadow1: value,dashboardGridShadow:value});
	}
	if(name === 'ShortcutMenuShadow'){
		this.setState({shadow2: value,ShortcutMenuShadow:value});
	}
	if(name === 'PluginOpenButtonShadow'){
		this.setState({shadow8: value,PluginOpenButtonShadow:value});
	}
	if(name === 'DropdownShadow'){
		this.setState({shadow9: value,DropdownShadow:value});
	}
	if(name === 'pluginMapShadow'){
		this.setState({shadow11: value,pluginMapShadow:value});
	}	
	if(name === 'ButtonShadow'){
		this.setState({shadow3: value,ButtonShadow:value});
	}
	if(name === 'TextareaShadow'){
		this.setState({shadow4: value,TextareaShadow:value});
	}
	if(name === 'DashboardListShadow'){
		this.setState({shadow5: value,DashboardListShadow:value});
	}
	if(name === 'PluginShadow'){
		this.setState({shadow6: value,PluginShadow:value});
	}
	if(name === 'SidemenuShadow'){
		this.setState({shadow7: value,SidemenuShadow:value});
	}
	if(name === 'shadowPluginInset'){
		this.setState({shadow10: value,shadowPluginInset:value});
	}
	if(name === 'lisitingShadow'){
		this.setState({shadow12: value,lisitingShadow:value});
	}

	if(name === 'shadowResult'){
		this.setState({shadow13: value,shadowResult:value});
	}
	
	if(name === 'shadowLeftSidebar'){
		this.setState({shadow18: value,shadowLeftSidebar:value});
	}

	if(name === 'shadowRightSidebar'){
		this.setState({shadow19: value,shadowRightSidebar:value});
	}	
	if(name === 'shadowPluginInsetLeft'){
		this.setState({shadow14: value,shadowPluginInsetLeft:value});
	}if(name === 'shadowPluginInsetTop'){
		this.setState({shadow15: value,shadowPluginInsetTop:value});
	}if(name === 'shadowPluginInsetRight'){
		this.setState({shadow16: value,shadowPluginInsetRight:value});
	}if(name === 'shadowPluginInsetBottom'){
		this.setState({shadow17: value,shadowPluginInsetBottom:value});
	}

	if(name === 'InputBoxShadow'){
		this.setState({shadow20: value,InputBoxShadow:value});
	}if(name === 'AIScreenTextareaShadow'){
		this.setState({shadow21: value,AIScreenTextareaShadow:value});
	}if(name === 'openButtonInnerShadow'){
		this.setState({shadow22: value,openButtonInnerShadow:value});
	}
	if(name === 'tableShadow'){
		this.setState({shadow23: value,tableShadow:value});
	}
	

	
	
	// this.setState({:value});
}
 onEditorChangetext = () => {
    // Directly get HTML from editor (auto includes <p>, <br>)
    const html = this.editorRef.current.getInstance().getHTML();
	this.setState({domain_data_description: html})
	console.log(html,'html')
   // onSave(html); // Save directly to DB
  };

  handleChangeTheme = sel => {
		this.setState({ selTheme : sel});
		this.setState({ theme_id : sel.value });
	}
setselectedtheme(sel) {
			
		this.setState({ selTheme: { value: sel.value, label: sel.label }, theme_id : sel.value });
}

  render() { 
	const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `${ this.state.hexColor }`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });
	const {selectedallmodel,selTheme} = this.state;
	let test1 = this.state.settings_access_code;
	//let test = Number(this.state.settings_access_code);
	
	const scripttype = '';
	
		/*const tester =	'<!-- Include <div> tag after the script -->\n<script src="http://car-c.uxt.design/plugin.js"></script>\n<div data-client="'+test+'"  id="car_container"></div>';
		*/
		
		
	let  tester =	'<script src="https://runadmin.UXT.design/plugin.js"></script> <div data-client="'+test1+'"  id="pet_container"></div>';


	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value }),
	);

	const {selectedFont,selectedfaqmodeluser,selectedfaqmodelguest ,selectedfaqmodeldoctor,selectedfaqmodeltechnician,selectedfaqmodelcompany,selectedinvite_discount,invite_discount_list,selected_template,selected_product_detailpage} = this.state;
	const style_text = {
	color: 'white',
    backgroundColor: '#000',
    padding: '9px 9px',
    minwidth: '49px',
    height: '37px',
	textalign:'center',
    texttransform: 'capitalize'
}

if(this.state.cancellation_fees_type == 'flat')
	{
		$('.cancellation_fee').html('Cancellation fees ($):')
		
	}else{
		$('.cancellation_fee').html('Cancellation fees (%):')
	}	
	if(this.state.reschedule_fees_type == 'flat')
	{
		$('.reschedule_fee').html('Reschedule fees ($):')
		
	}else{
		$('.reschedule_fee').html('Reschedule fees (%):')
	}	

	
    return (
      <div className="wrapper"> 
 
	  <Header />
	  <MenuSidebar currentpage="setting" />		

	
	<div className="content">	
		<div className="content-wrapper">
		  <div class="content-wrapper-before"></div>
			<div className="content-body setting-main-head leaa-admin-head card">
			<form className="settings" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
			<div className="form-wrapper">
			<div className="success_message"></div>
			<div className="title">
				<h4>Settings</h4>
			</div>
			<div className="form-row">
			<div className="form-left">

       

				<div className="form-group">
				{localStorage.getItem('admin_id') == 1 ?<label>Site Name:</label>:<label>Company Name<span class="required" style={{ color: "red" }} > * </span>
:</label>}
					
					<input type="text" name="settings_site_title" onChange={this.handleInputChange} className="form-control" value={this.state.settings_site_title} />
					<div className="errorsettings_site_title"></div>
				</div>
				<div className="form-group">					
					<label>From Name<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" name="settings_from_name" onChange={this.handleInputChange} className="form-control"value={this.state.settings_from_name} />
					<div className="errorsettings_from_name"></div>
				</div>
				<div className="form-group">
					<label>From Email<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" name="settings_from_email"  onChange={this.handleInputChange} className="form-control" value={this.state.settings_from_email} />
					<div className="errorsettings_from_email"></div>
				</div>
			
				

				<div className="default-font">
			  <div className="form-group">
					<label>Font:</label>
				     <Select 
                         options={fonts}  
                         value={selectedFont?selectedFont:{ value: '0', label: 'Select Font Type' }}
                         onChange={this.handleChangeFont}
                         placeholder="Select Font Type" />
					<div className="errorfont"></div>
				</div>
				</div> 

				<div className="form-group">
					<label>Dog 3D Model:</label>
					<div className="choose-file">
					<div className="dogimage_success"></div>
					<span className="profile_btn"><input type="file" name="dogimage" onChange={this.onChangeHandlerDog} /></span>
					</div>
					{this.state.dogimage_preview != '' ? <img src={this.state.dogimage_preview} width={100} height={100} />:''}
					
				</div>
				
			
			</div>
			<div className="form-right">

				<div className="form-group">					
					{localStorage.getItem('admin_id') == 1 ? <label>Admin Email<span class="required" style={{ color: "red" }} > * </span>
						:</label>:<label>Company Email<span class="required" style={{ color: "red" }} > * </span>
						:</label>} 
					<input type="text" className="form-control" onChange={this.handleInputChange} name="settings_admin_email" value={this.state.settings_admin_email} />
					<div className="errorsettings_admin_email"></div>
				</div>
				
				<div className="form-group">
					<label>Contact No<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" className="form-control" name="settings_mobileno"  onChange={this.handleInputChange} value={this.state.settings_mobileno}/>
					<div className="errorsettings_mobileno"></div>
				</div>

				<div className="form-group"> 
					<label>Email Footer Content<span class="required" style={{ color: "red" }} > * </span>
							:</label>
					<input type="text" className="form-control" name="settings_email_footer" onChange={this.handleInputChange} value={this.state.settings_email_footer}/>
					<div className="errorsettings_email_footer"></div>
				</div>
				
				<div className="form-group">
					<label>Email Header Logo:</label>
					<div className="choose-file">
					<div className="emailimage_success"></div>
					<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandlerEmailLogo} /></span>
					</div>
					{this.state.emailimage_preview != '' ? <img src={this.state.emailimage_preview} width={100} height={100} />:''}					
				</div>


				<div className="form-group">
					<label>Stroke Color:</label><br></br>
					<input type="color" id="head" name="stroke_color" value={this.state.stroke_color} onChange={this.handleInputChange} />
            	</div>
				<div className="form-group">
					<label>Cat 3D Model:</label>
					<div className="choose-file">
					<div className="catimage_success"></div>
					<span className="profile_btn"><input type="file" name="catimage" onChange={this.onChangeHandlerCat} /></span>
					</div>
					{this.state.catimage_preview != '' ? <img src={this.state.catimage_preview} width={100} height={100} />:''}
					
				</div>

				


				{/* { localStorage.getItem('admin_id') == 1 ? <div className="form-group site-bg-clr"> 
				<label>Site Background Color: </label>
						<div style={ styles.swatch } onClick={ this.handleClick }>
						<div style={ styles.color } />
						</div>
						{ this.state.displayColorPicker ? <div style={ styles.popover }>
						<div style={ styles.cover } onClick={ this.handleClose }/>
						<SketchPicker color={ this.state.color } onChange={ this.handleChange } />
						</div> : null }
				</div> : '' } */}

				  
			</div>				
			</div>	
			{/* -------------invite friend content start-------------- */}

			<div className="title">
				<h4>Invite Friend Setting</h4>
		   </div> 

			<div className="form-row">
			<div className="form-left">
				<div className='form-group'>
					<label> Heading </label>

					<MyEditor id="aifeed_desc" initialData={this.state.invite_friend_heading} onEditorChange={this.onEditorChangeinvitefrndHead}> </MyEditor>


					{/* <CKEditor
						data={this.state.invite_friend_heading}
						//data={templatecontent}
						onChange={this.onEditorChangeinvitefrndHead}
						type="classic"
					/>  */}


					<div className="error_invite_friend_heading"></div>
				</div>
				<div className='form-group'>
					<label> Short Description </label>

					<MyEditor2 id="aifeed_desc" initialData={this.state.invite_friend_short_description} onEditorChange={this.onEditorChangeinvitefrndShortDesc}> </MyEditor2>

					{/* <CKEditor
						data={this.state.invite_friend_short_description}
						//data={templatecontent}
						onChange={this.onEditorChangeinvitefrndShortDesc}
						type="classic"
					/>  */}
					<div className="error_invite_friend_short_description"></div>
				</div>
			
			</div> 
			<div className="form-right">
			<div className='form-group'>
					<label>Description </label>
					<MyEditor1 id="aifeed_desc" initialData={this.state.invite_friend_description} onEditorChange={this.onEditorChangeinvitefrndDesc}> </MyEditor1>
					{/* <CKEditor
						data={this.state.invite_friend_description}
						//data={templatecontent}
						onChange={this.onEditorChangeinvitefrndDesc}
						type="classic"
					/>  */}
					<div className="error_invite_friend_description"></div>
				</div>
				{/* <div className="default-font"> */}
					<div className="form-group">
						<label>Invite friends discount:</label>
						<Select 
							options={invite_discount_list}  
							value={selectedinvite_discount?selectedinvite_discount:{ value: '0', label: 'Select Invite Discount' }}
							onChange={this.handleChangeDiscount}
							placeholder="Select Font Type" />
						<div className="errorsettings_discount"></div>
					</div>
				{/* </div>  */}
				<div className="form-group">
					<label>Image:</label>
					<div className="choose-file">
					<div className="inviteimage_success"></div>
					<span className="profile_btn"><input type="file" name="inviteimage" onChange={this.onChangeHandlerinviteimage} /></span>
					</div>
					{this.state.inviteimage_preview != '' ? <img src={this.state.inviteimage_preview} width={100} height={100} />:''}
				</div>		

				

			</div>
      	</div>	
		{/* -------------invite friend content setting end-------------- */}
			{/* -------------chat ai setting start-------------- */}

			<div className="title">
				<h4>Chat AI Setting</h4>
		   </div> 

			<div className="form-row">
			<div className="form-left">
			<div className="form-group">
			<label>Chat AI type: </label>				
				</div>
				{/* <div className="form-group">
					<label>Common / Guest Conversation</label>					
				</div>
				<div className="form-group">
					<label>User Conversation</label>					
				</div>

				<div className="form-group">
					<label>Vet Conversation</label>					
				</div>
				
				<div className="form-group">
					<label>Technician Conversation</label>					
				</div>
				<div className="form-group">
					<label>Company Conversation</label>					
				</div> */}
				<div className="form-group">
					<label>API Key</label>					
				</div>
				<div className="form-group">
					<label>ChatGPT Model ID</label>				
				</div>
				<div className="form-group">
						<label>Chat name: </label>
						
				</div>
			</div> 
			<div className="form-right">
			<div className="form-group">
						
						<input onChange={this.handleInputChange} type="radio" name="aichat_type" checked={this.state.aichat_type=='text'?'chekced':''} value="text"/>
						<span>Text</span>
							<input onChange={this.handleInputChange} type="radio"  name="aichat_type" checked={this.state.aichat_type=='chat'?'chekced':''} value="chat"/>
						<span>Chat </span>
					</div> 
			<div className='form-group'> </div>
			<br>
			</br>
			<br>
			</br>
			{/* <div className="form-group">					
				
				<Select 
					options={this.state.faqmodelguest}  
					value={selectedfaqmodelguest?selectedfaqmodelguest:{ value: '0', label: 'Select guest ai model' }}
					onChange={this.handleChangeAimodelguest}
					placeholder="Select AI Model ID" 
				/>			
			</div>

			<div className="form-group">					
				<Select 
					options={this.state.faqmodeluser}  
					value={selectedfaqmodeluser?selectedfaqmodeluser:{ value: '0', label: 'Select user ai model' }}
					onChange={this.handleChangeAimodeluser}
					placeholder="Select AI Model ID" 
				/>			
			</div>			

			<div className="form-group">					
				<Select 
					options={this.state.faqmodeldoctor}  
					value={selectedfaqmodeldoctor?selectedfaqmodeldoctor:{ value: '0', label: 'Select vet ai model' }}
					onChange={this.handleChangeAimodeldoctor}
					placeholder="Select AI Model ID" 
				/>			
			</div>	
			<div className="form-group">					
				<Select 
					options={this.state.faqmodeltechnician}  
					value={selectedfaqmodeltechnician?selectedfaqmodeltechnician:{ value: '0', label: 'Select technician ai model' }}
					onChange={this.handleChangeAimodeltechnician}
					placeholder="Select AI Model ID" 
				/>			
			</div>	
			<div className="form-group">					
				<Select  
					options={this.state.faqmodelcompany}  
					value={selectedfaqmodelcompany?selectedfaqmodelcompany:{ value: '0', label: 'select company ai model' }}
					onChange={this.handleChangeAimodelcompany}
					placeholder="Select AI Model ID" 
				/>			
			</div>	 */}

			<br>
			</br>
			<br>
			</br>
			<div className="form-group">					
				<input type="text" className="form-control" name="chat_api_key" onChange={this.handleInputChange} value={this.state.chat_api_key}/>
				<div className="errorsettings_chat_api_key"></div>		
			</div>	
			<div className="form-group">		
				<Select 
					options={this.state.all_models}  
					value={selectedallmodel?selectedallmodel:{ value: '0', label: 'Select ai model' }}
					onChange={this.handleChangeAllmodelguest}
					placeholder="Select AI Model ID" 
				/>	
				<div className="errorchat_model"></div>
			</div>
			<div className="form-group">	
				<input type="text" className="form-control" name="chat_name"  onChange={this.handleInputChange} value={this.state.chat_name}/>
				<div className="errorsettings_chat_name"></div>
			</div>
			</div>
      	</div>	

			{/* <div className="title">
					<h4>Feed domain data</h4>
			</div> */}
		  		
			{/* <div className="form-group">
			<label>Type</label>

						<input onChange={this.handleInputChange} type="radio" name="type" checked={this.state.completion_type=='text'?'chekced':''} value="text"/>
						<span>Text</span>
							<input onChange={this.handleInputChange} type="radio"  name="type" checked={this.state.completion_type=='chat'?'chekced':''} value="chat"/>
						<span>Chat </span>
					</div>  */}
			<div className="form-group">					

{/* 		
		<Editor
        ref={this.editorRef}
        initialValue={this.state.finetune_content !== null && this.state.finetune_content !== undefined
			? this.state.finetune_content
			: this.state.domain_data_description}
        previewStyle="vertical"
        height="400px"
        initialEditType="wysiwyg" // ✅ use WYSIWYG mode
        useCommandShortcut={true}
		onChange={this.onEditorChangetext.bind(this)} 
      /> */}

				<div className="errordescription"></div>
				{/* <button className='ai-feedbtn' onClick={this.handleSave}>AI Feed</button> */}
			</div>	


			<div className="title">
				<h4>Appointment Settings</h4>
			</div>  
			<div className="form-row">

			


				<div className="form-left">
					<div className="form-group"> 
						<label className='location_distance'>Doctor Location Distance(mi)<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="location_distance" onChange={this.handleInputChange} value={this.state.location_distance}/>
						<div className="errorsettings_location_distance"></div>
					</div>
					<div className="form-group">
						<label>Cancellation fees type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="cancellation_fees_type" checked={this.state.cancellation_fees_type=='flat'?'chekced':''} value="flat"/>
						<span>Flat Amount </span>
							<input onChange={this.handleInputChange} type="radio"  name="cancellation_fees_type" checked={this.state.cancellation_fees_type=='percentage'?'chekced':''} value="percentage"/>
						<span>Percentage </span>
					</div> 
					<div className="form-group"> 
						<label className='cancellation_fee'>Cancellation fees<span class="required" style={{ color: "red" }} > * </span>
:</label>
						<input type="text" className="form-control" name="cancellation_fee" onChange={this.handleInputChange} value={this.state.cancellation_fee}/>
						<div className="errorsettings_cancellation_fee"></div>
					</div>

					<div className="form-group"> 
						<label>Cancellation Hours<span class="required" style={{ color: "red" }} > * </span>
:</label>
						<input type="text" className="form-control" name="cancellation_hr" onChange={this.handleInputChange} value={this.state.cancellation_hr}/>
						<div className="errorsettings_cancellation_hr"></div>
					</div>
					<div className='form-group'>
						<label> Consent Form</label>
						<MyEditor3 id="aifeed_desc" initialData={this.state.consent_form_agree} onEditorChange={this.onEditorChange}> </MyEditor3>
						{/* <CKEditor
							data={this.state.consent_form_agree}
							//data={templatecontent}
							onChange={this.onEditorChange}
							type="classic"
						/>  */}

						{/* <textarea type="text" rows="7" name="consent_form_agree" onChange={this.handleInputChange} className="form-control" value={this.state.consent_form_agree} /> */}
						<div className="error_consent"></div>
					</div>
				
				</div>

				<div className="form-right">
					<div className="form-group">
						<label>Reschedule fees type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="reschedule_fees_type" checked={this.state.reschedule_fees_type=='flat'?'chekced':''} value="flat"/>
						<span>Flat Amount</span>
							<input onChange={this.handleInputChange} type="radio"  name="reschedule_fees_type" checked={this.state.reschedule_fees_type=='percentage'?'chekced':''} value="percentage" />
						<span>Percentage</span>
					</div> 
					<div className="form-group"> 
						<label className='reschedule_fee'>Reschedule fees<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="reschedule_fee" onChange={this.handleInputChange} value={this.state.reschedule_fee}/>
						<div className="errorsettings_reschedule_fee"></div>
					</div>
					<div className="form-group"> 
						<label>Reschedule Hours<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="reschedule_hr" onChange={this.handleInputChange} value={this.state.reschedule_hr}/>
						<div className="errorsettings_reschedule_hr"></div>
					</div>

					<div className="form-group"> 
						<label>Mail Send Time<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="mailsend_doctor_time" onChange={this.handleInputChange} value={this.state.mailsend_doctor_time}/>
						<div className="errorsettings_mailsend_doctor_time"></div>
					</div>	

					<div className="form-group"> 
						<label>Vet consultant fees($)<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="basic_consultant_fee" onChange={this.handleInputChange} value={this.state.basic_consultant_fee}/>
						<div className="errorsettings_basic_consultant_fee"></div>
					</div>

					<div className="form-group"> 
						<label>Company Booking Fee<span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="company_consultant_fee" onChange={this.handleInputChange} value={this.state.company_consultant_fee}/>
						<div className="errorsettings_company_consultant_fee"></div>
					</div>
					<div className="form-group"> 
						<label>Shopping Commission % <span class="required" style={{ color: "red" }} > * </span>
						:</label>
						<input type="text" className="form-control" name="shopping_fee" onChange={this.handleInputChange} value={this.state.shopping_fee}/>
						<div className="errorsettings_shopping_fee"></div>
					</div>

				</div>
			</div>
		    <div className="title">
				<h4>Mail Configuration Settings</h4>
			</div> 
			
			 <div className="form-group">
				    <input onChange={this.handleInputChange} type="checkbox"  name="settings_mail_from_smtp" checked={this.state.smtp_checked}/>
	                <span>Send Mail From Smtp</span>
            </div> 

		 <div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Smtp Host:</label>
					<input type="text" className="form-control" name="settings_smtp_host" onChange={this.handleInputChange}  value={(this.state.settings_smtp_host != 'null')?this.state.settings_smtp_host:''}/>
					<div className="errorsettings_smtp_host"></div>
				</div>
				<div className="form-group">					
					<label>Smtp Username:</label>
					<input type="text" className="form-control" name="settings_smtp_user"  onChange={this.handleInputChange}  value={(this.state.settings_smtp_user != 'null')?this.state.settings_smtp_user:''} />
					<div className="errorsettings_smtp_user"></div>
				</div>					
				<div className="form-group">
					<label>Smtp Password:</label>
					<input type="password" className="form-control" name="settings_smtp_pass" onChange={this.handleInputChange}  value={(this.state.settings_smtp_pass != 'null')?this.state.settings_smtp_pass:''} />
				<div className="errorsettings_smtp_pass"></div>
				</div>
			</div>			
			<div className="form-right">
				<div className="form-group">					
					<label>Smtp Port:</label>
					<input type="text" className="form-control"  name="settings_smtp_port" onChange={this.handleInputChange}  value={(this.state.settings_smtp_port != 'null')?this.state.settings_smtp_port:''} />
				<div className="errorsettings_smtp_port"></div>
				</div>
				<div className="form-group"> 
					<label>Mail Path:</label>
					<input type="text" className="form-control" name="settings_mailpath" onChange={this.handleInputChange} placeholder=""  value={(this.state.settings_mailpath != 'null')?this.state.settings_mailpath:''}/>
				</div>
			</div>	
			</div> 
			
			<div className="title">
				<h4>Commision Settings</h4>
			</div>  

			
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Commision Percentage %<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" className="form-control" name="settings_commision_amount" onChange={this.handleInputChange}  value={(this.state.settings_commision_amount != 'null')?this.state.settings_commision_amount:''}/>
					<div className="errorsettings_commision_amount"></div>
				</div>
				</div>
				</div> 

				

		<div className="title">
				<h4>Domain & Embed Code</h4>
			</div> 

			{/* <div className="form-row">
						<div className={`shadow-input-popup-action ${this.state.shortcutBoxShadowSt ? 'show' : ''}`}>
							<span className='shadow-input-close' onClick={this.boxShadowFunc.bind(this,'')}>X</span>
							<div className='title'>
								<h4>Shortcut box shadow1</h4>
							</div>

							<div className='shadow-picker-container d-flex w-100 justify-content-between'>
								<ShadowPicker

								value={this.state.editshadow=='shortcutBoxShadowDet'&&this.state.shadow}
								name={this.state.editshadow}
								// onChange={this.shadowchange}
								onChange={(value) => {
								this.shadowchange(value);
									// this.setState({shadow : value});
								}}

								className='shadow-picker'
								/>
								{this.state.editshadow=='shortcutBoxShadowDet'&&<div className='shadow-box' style={{boxShadow: this.state.shadow}}>
								</div>}
								{this.state.editshadow=='dashboardGridShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow1}}>
								</div>}
								{this.state.editshadow=='ShortcutMenuShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow2}}>
								</div>}
								{this.state.editshadow=='ButtonShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow3}}>
								</div>}
								{this.state.editshadow=='TextareaShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow4}}>
								</div>}
								{this.state.editshadow=='DashboardListShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow5}}>
								</div>}

								{this.state.editshadow=='PluginShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow6}}>
								</div>}
								{this.state.editshadow=='SidemenuShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow7}}>
								</div>}

								{this.state.editshadow=='shadowPluginInset'&&<div className='shadow-box' style={{boxShadow: this.state.shadow10}}>
								</div>}								

								{this.state.editshadow=='PluginOpenButtonShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow8}}>
								</div>}

								{this.state.editshadow=='DropdownShadow'&&<div className='shadow-box' style={{boxShadow: this.state.shadow9}}>
								</div>}

							</div>
							<div className='d-flex w-100 justify-content-end gap-2 mt-5'>
								<button type="button" className='shadow-btn' onClick={this.saveboxShadowFunc.bind(this)}>Save</button>
							</div>
						</div>
					</div> */}

			<div className="form-row">
						<div className={`shadow-input-popup-action ${this.state.shortcutBoxShadowSt ? 'show' : ''}`}>
							<span className='shadow-input-close' onClick={this.boxShadowFunc.bind(this)}>X</span>
							<div className='title'>
								 <h4>{
									this.state.editshadow=='dashboardGridShadow'?'Dashboard Shadow Grid':
									this.state.editshadow=='ShortcutMenuShadow'?'Shortcut Menu Shadow':
									this.state.editshadow=='ButtonShadow'?'Button Shadow':
									this.state.editshadow=='PluginOpenButtonShadow'?'Plugin Open Button Shadow':
									this.state.editshadow=='DropdownShadow'?'Dropdown Menu Shadow':
									this.state.editshadow=='pluginMapShadow'?'Map Shadow':					
									this.state.editshadow=='TextareaShadow'?'Textarea Shadow':
									this.state.editshadow=='DashboardListShadow'?'Dashboard List Shadow':
									this.state.editshadow=='PluginShadow'?'Plugin Shadow':
									this.state.editshadow=='SidemenuShadow'?'Sidemenu Shadow':
									this.state.editshadow=='shadowPluginInset'?'Plugin Inner Shadow':
									this.state.editshadow=='lisitingShadow'?'Lisiting Shadow':
									
									this.state.editshadow=='shadowResult'?'Result Shadow':
									this.state.editshadow=='shadowPluginInsetLeft'?'Plugin Inset Left Shadow':
									this.state.editshadow=='shadowLeftSidebar'?'Left Sidebar Shadow':
									this.state.editshadow=='shadowRightSidebar'?'Right Sidebar Shadow':
									this.state.editshadow=='shadowPluginInsetTop'?'Plugin Inset Top Shadow':
									this.state.editshadow=='shadowPluginInsetRight'?'Plugin Inset Right Shadow':
									this.state.editshadow=='shadowPluginInsetBottom'?'Plugin Inset Bottom Shadow':

									this.state.editshadow=='InputBoxShadow'?'Input Box Shadow':
									this.state.editshadow=='AIScreenTextareaShadow'?'AI Screen Textarea Shadow':
									this.state.editshadow=='openButtonInnerShadow'?'Open Button Inner Shadow':
									this.state.editshadow=='tableShadow'?'Table Shadow':
									
									'' } </h4> 
							</div>

							<div className='shadow-picker-container d-flex w-100 justify-content-between'>
								<ShadowPicker
								// value={this.state.shadow}
								value={this.state.editshadow=='shortcutBoxShadowDet'?this.state.shadow:
									this.state.editshadow=='dashboardGridShadow'?this.state.shadow1:
									this.state.editshadow=='ShortcutMenuShadow'?this.state.shadow2:
									this.state.editshadow=='ButtonShadow'?this.state.shadow3:
									this.state.editshadow=='PluginOpenButtonShadow'?this.state.shadow8:
									this.state.editshadow=='DropdownShadow'?this.state.shadow9:
									this.state.editshadow=='pluginMapShadow'?this.state.shadow11:			
									this.state.editshadow=='TextareaShadow'?this.state.shadow4:
									this.state.editshadow=='DashboardListShadow'?this.state.shadow5:
									this.state.editshadow=='PluginShadow'?this.state.shadow6:
									this.state.editshadow=='SidemenuShadow'?this.state.shadow7:
									this.state.editshadow=='shadowPluginInset'?this.state.shadow10:
									this.state.editshadow=='lisitingShadow'?this.state.shadow12:

									this.state.editshadow=='shadowResult'?this.state.shadow13:
									this.state.editshadow=='shadowPluginInsetLeft'?this.state.shadow14:
									this.state.editshadow=='shadowLeftSidebar'?this.state.shadow18:
									this.state.editshadow=='shadowRightSidebar'?this.state.shadow19:
									
									this.state.editshadow=='shadowPluginInsetTop'?this.state.shadow15:this.state.editshadow=='shadowPluginInsetRight'?this.state.shadow16:
									this.state.editshadow=='shadowPluginInsetBottom'?this.state.shadow17:

									this.state.editshadow=='InputBoxShadow'?this.state.shadow20:
									this.state.editshadow=='AIScreenTextareaShadow'?this.state.shadow21:
									this.state.editshadow=='openButtonInnerShadow'?this.state.shadow22:
									this.state.editshadow=='tableShadow'?this.state.shadow23:

									
									
								'' }
								
								onChange={(value) => {
									this.shadowchange(value);
										// this.setState({shadow : value});
									}}
								className='shadow-picker'
								/>
								
								<div className='shadow-box' style={{boxShadow: this.state.shadow}}>
								</div>
							</div>

							<div className='d-flex w-100 justify-content-end gap-2 mt-5'>
								<button type="button" className='shadow-btn' onClick={this.saveboxShadowFunc.bind(this)}>Save</button>
							</div>
						</div>
					</div>

		<div className="form-row">
				<div className="form-left">
				<div className="form-group">
						<label>Embed Code:</label>
						<p className="right-side-header"  id="embed_code" name="settings_embedcode" value={tester} title="Copy Text" >{tester}</p>
						<br></br>
						<a id='copytext' style={style_text} onClick={this.writeText}   >Copy  </a> <br></br>
						<div><br></br><div className="copied_title"></div></div>
						<div className="errorsettings_embedcode_title"></div>
					</div>
					
					<div className='form-group'>
				     <h4>Google Analytics code </h4>
					 <textarea type="text" name="google_analystic_code" onChange={this.handleInputChange} className="form-control" value={this.state.google_analystic_code} />
					</div>
				</div>	
				<div className="form-right">

				

				    <div className='form-group'>
				     <h4>Domain </h4>
				    <div className="domain-url">
					<Addinputsimple myCallback={this.myCallback} domainname={this.state.domainSets} count_domain={this.state.count_domain}/>
					</div>
					</div>
				
				</div>				
			</div>

			<div className="title">
				<h4>Plugin Setting</h4>
			</div> 

			<div className="form-row">			
				<div className="form-left">
					<div className="form-group">
						<label>Plugin Position : </label>
						<Select  
							options={this.state.plugin_position_list}  
							value={this.state.selected_plugin_position?this.state.selected_plugin_position:{value:'',label:'select dashboard template' }}
							onChange={this.handleChangeplugin_position}
							placeholder="Select plugin position" 
						/>
						
						{/* <input onChange={this.handleInputChange} type="radio"  name="st_position" checked={this.state.st_position_checked}/>
	                    <span>Fixed</span>

						<input onChange={this.handleInputChange} type="radio"  name="st_position" checked={this.state.st_position_checked===false?true:false}/>
	                    <span>Absolute</span> */}
					</div>	
					<h5 className="mt-5">Plugin Position (Numbers Only)</h5>				
				</div>
				<div className="form-right">
						{this.state.selected_plugin_positionval=='absolute'&&<div className="form-group">
						<label>Position Height : </label>
						<input type="number" className="form-control" name="pluginPositionHeight"  onChange={this.handleInputChange} value={this.state.pluginPositionHeight}/>
						{/* <div className="errorsettings_st_position_top"></div> */}
						</div>}
					</div>
			</div>

			 
			 <div className="form-row">			
				<div className="form-left">
					{/* <div className="form-group">
						<label>Position : </label>
						<input onChange={this.handleInputChange} type="radio"  name="st_position" checked={this.state.st_position_checked}/>
	                    <span>Fixed</span>

						<input onChange={this.handleInputChange} type="radio"  name="st_position" checked={this.state.st_position_checked===false?true:false}/>
	                    <span>Absolute</span>
					</div> */}

					<div className="form-group">
						<label>Top: %</label>
						<input type="number" className="form-control" name="st_position_top"  onChange={this.handleInputChange} value={this.state.st_position_top}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>Left : %</label>
						<input type="number" className="form-control" name="st_position_left"  onChange={this.handleInputChange} value={this.state.st_position_left}/>
						<div className="errorsettings_st_position_left"></div>
					</div>	

					<div className="form-group">
						<label>AI Fine Tune model ID: </label>
						<input type="text" className="form-control" name="ai_fine_tune_model_id"  onChange={this.handleInputChange} value={this.state.ai_fine_tune_model_id}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>
					</div>
				<div className="form-right">


					

					
					<div className="form-group">
						<label>Bottom: %</label>
						<input type="number" className="form-control" name="st_position_bottom"  onChange={this.handleInputChange} value={this.state.st_position_bottom}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>

					<div className="form-group">
						<label>Right : %</label>
						<input type="number" className="form-control" name="st_position_right"  onChange={this.handleInputChange} value={this.state.st_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>

					

					 <div className="form-group">
						<label>Header category limit: </label>
						<input type="number" className="form-control" name="header_cat_limit"  onChange={this.handleInputChange} value={this.state.header_cat_limit}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>
				</div>	
				</div>
				<div className="title mt-5">
					<h4>Plugin Inner Space
				</h4>
					</div>
				<div className="form-row">			
				<div className="form-left">
						{/* <div> */}
					 
					<div className="form-group">
						<label>Top Space: </label>
						<input type="text" className="form-control" name="pluginTopSpace"  onChange={this.handleInputChange} value={this.state.pluginTopSpace}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div><div className="form-group">
						<label>Bottom Space: </label>
						<input type="text" className="form-control" name="pluginBottomSpace"  onChange={this.handleInputChange} value={this.state.pluginBottomSpace}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>
					
					{/* <div className="form-group">
						<label>Letter spacing: </label>
						<input type="text" className="form-control" name="letter_spacing"  onChange={this.handleInputChange} value={this.state.letter_spacing}/>
						<div className="errorsettings_letter_spacing"></div>
					</div> */}

					<div className="form-group">
						<label>Product Detail View: </label>					
						<Select  
							options={this.state.product_detailpage}  
							value={selected_product_detailpage?selected_product_detailpage:{value:'normal',label:'Normal Detail View'}}
							onChange={this.handleChangeproductdetailpage}
							placeholder="Select Product Detail View" 
						/>
					</div>	

					<div className="form-group">
						<label>Dashboard Template: </label>					
						<Select  
							options={this.state.dahboard_template}  
							value={selected_template?selected_template:{value:'',label:'select dashboard template' }}
							onChange={this.handleChangeDahboardTemplate}
							placeholder="Select dahboard template" 
						/>
					</div>	
					{this.state.selected_template.value ==1 ? <img src={template1} width={100} height={100}  onClick={this.showTemplatePopup}  />:''}
					{this.state.selected_template.value ==2 ? <img src={template2} width={100} height={100} onClick={this.showTemplatePopup} />:''}
					{this.state.selected_template.value ==3 ? <img src={template3} width={100} height={100} onClick={this.showTemplatePopup} />:''}
					<div className="form-group">
						<label>Plugin Outer Space in Mobile  </label>
						<input onChange={this.handleInputChange} type="checkbox"  name="mobile_outer_space" checked={this.state.mobile_outer_space}/>
	                    {/* <span>Show</span> */}
					</div>

					<div className="form-group">
						<label>Show Tab icons(Menu): </label>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
					    <input onChange={this.handleInputChange} type="radio" name="category_icons" checked={this.state.category_icons_yes}/>
		                <span>Yes</span>
						</div>
						<div>
		                 <input onChange={this.handleInputChange} type="radio"  name="category_icons" checked={this.state.category_icons_no}/>
		                <span>No</span>
						</div>
						</div>
 					</div> 
					
					 <div className="form-group">
						<label>Product View: </label>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
					    <input onChange={this.handleInputChange} type="radio" name="product_view" checked={this.state.product_view_list}/>
		                <span>List View</span></div><div>
		                 <input onChange={this.handleInputChange} type="radio"  name="product_view" checked={this.state.product_view_grid}/>
		                <span>Grid View</span></div>
						</div>
 					</div> 
					 <div className="form-group">
						<label>Payment Form:</label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
							<input onChange={this.handleInputChange} type="radio" name="payment_form" checked={this.state.payment_form=='normal'?'chekced':''} value="normal"/>
						<span>Normal</span></div><div>
						<input onChange={this.handleInputChange} type="radio"  name="payment_form" checked={this.state.payment_form=='widget'?'chekced':''} value="widget"/>
						<span>Widget</span></div>
						</div>
					</div> 

					<div className="form-group">
						<label>Product Layout: </label>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
					    <input onChange={this.handleInputChange} type="radio" name="product_layout" checked={this.state.product_layout2_checked}/>
		                <span>2 Layout</span></div><div>
		                 <input onChange={this.handleInputChange} type="radio"  name="product_layout" checked={this.state.product_layout3_checked}/>
		                <span>3 Layout</span></div>
						</div>
 					</div> 
					 <div className="form-group">
						<label>Notification Popup Theme: </label>
						<br/>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
					    <input onChange={this.handleInputChange} type="radio" name="np_theme" value="Black" checked={(this.state.np_theme == "Black" ? "checked" : "" )}/>
		                <span>Black bg with White text</span>
						<br/>
						</div>
						<div>
		                 <input onChange={this.handleInputChange} type="radio"  name="np_theme" value="White" checked={(this.state.np_theme == "White" ? "checked" : "" )}/>
		                <span>White bg with Black text</span>
						</div>
						</div>
 					</div>
					</div>
					<div className="form-right">
				{/* </div> */}
				{/* <div className="form-right">


					

					
					<div className="form-group">
						<label>Bottom: %</label>
						<input type="number" className="form-control" name="st_position_bottom"  onChange={this.handleInputChange} value={this.state.st_position_bottom}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>

					<div className="form-group">
						<label>Right : %</label>
						<input type="number" className="form-control" name="st_position_right"  onChange={this.handleInputChange} value={this.state.st_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>

					

					 <div className="form-group">
						<label>Header category limit: </label>
						<input type="number" className="form-control" name="header_cat_limit"  onChange={this.handleInputChange} value={this.state.header_cat_limit}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					{/* </div>  */}


					
					 <div className="form-group">
						<label>Left Space: </label>
						<input type="number" className="form-control" name="pluginLeftSpace"  onChange={this.handleInputChange} value={this.state.pluginLeftSpace}/>
					</div> 
					<div className="form-group">
						<label>Right Space: </label>
						<input type="number" className="form-control" name="pluginRightSpace"  onChange={this.handleInputChange} value={this.state.pluginRightSpace}/>
					</div>
					

					 <div className="form-group">
						<label>Plugin Size: </label>
						<br/>
					    {/* <input onChange={this.handleInputChange} type="radio" name="plugin_size" value="600" checked={(this.state.plugin_size == "600" ? "checked" : "" )}/>
		                <span>600px</span>
						
		                 <input onChange={this.handleInputChange} type="radio"  name="plugin_size" value="700" checked={(this.state.plugin_size == "700" ? "checked" : "" )}/>
		                <span>700px</span> */}
						{/* <input onChange={this.handleInputChange} type="radio"  name="plugin_size" value="900" checked={(this.state.plugin_size == "900" ? "checked" : "" )}/>
		                <span>900px</span> */}
						<select name="plugin_size" className="form-control" onChange={this.handleInputChange}>
							<option selected={this.state.plugin_size == '600'} value="600">600px</option>
							<option selected={this.state.plugin_size == '700'} value="700">700px</option>
							<option selected={this.state.plugin_size == '800'} value="800">800px</option>
							<option selected={this.state.plugin_size == '900'} value="900">900px</option>
							<option selected={this.state.plugin_size == '1000'} value="1000">1000px</option>						
						</select>
 					</div>

					{/* <div className="form-group">
						<label>Plugin Radius: </label>
						<input type="number" className="form-control" name="plugin_radius"  onChange={this.handleInputChange} value={this.state.plugin_radius}/>
					</div> */}

					 <div className="form-group">
						<label>Show Product checkbox for user:</label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
							<input onChange={this.handleInputChange} type="radio" name="product_view_checkbox" checked={this.state.product_view_checkbox=='show'?'chekced':''} value="show"/>
						<span>Show</span></div><div>
						<input onChange={this.handleInputChange} type="radio"  name="product_view_checkbox" checked={this.state.product_view_checkbox=='hide'?'chekced':''} value="hide"/>
						<span>Hide</span></div>
						</div>
					</div> 

					<div className="form-group">
						<label>Display Tab:</label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
							<div>
							<input onChange={this.handleInputChange} type="radio" name="display_tab" checked={this.state.display_tab=='adsTab'?'chekced':''} value="adsTab"/>
						<span>Advertisement</span>
						</div><div>
						<input onChange={this.handleInputChange} type="radio"  name="display_tab" checked={this.state.display_tab=='mainTab'?'chekced':''} value="mainTab"/>
						<span>Main Tab</span>
							</div><div>
						<input onChange={this.handleInputChange} type="radio"  name="display_tab" checked={this.state.display_tab=='aiwidget'?'chekced':''} value="aiwidget"/>
						<span>AI Widget</span>
						</div>
						</div>
					</div> 

					<div className="form-group">
						<label>Show Product checkbox for Vet:</label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
						<div>
							<input onChange={this.handleInputChange} type="radio" name="product_doctor_checkbox" checked={this.state.product_doctor_checkbox=='show'?'chekced':''} value="show"/>
						<span>Show</span></div><div>
						<input onChange={this.handleInputChange} type="radio"  name="product_doctor_checkbox" checked={this.state.product_doctor_checkbox=='hide'?'chekced':''} value="hide"/>
						<span>Hide</span>
						</div></div>
					</div> 

					<div className="form-group">
						<label>Dashboard wider view:</label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
						<div>
							<input onChange={this.handleInputChange} type="radio" name="dashboard_view" checked={this.state.dashboard_view=='1'?'chekced':''} value="1"/>
						<span>1 Column</span></div><div>
						<input onChange={this.handleInputChange} type="radio"  name="dashboard_view" checked={this.state.dashboard_view=='2'?'chekced':''} value="2"/>
						<span>2 Column</span>
						</div></div>
					</div> 

					<div className="form-group">
						<label>Dashboard View: </label><br></br>
						<div className='d-flex gap-4 flex-wrap'>
						<div>
						<input onChange={this.handleInputChange} type="radio" name="dashboard" checked={this.state.dashboard_view_list}/>
						<span>List View</span></div>
						<div>

							<input onChange={this.handleInputChange} type="radio"  name="dashboard" checked={this.state.dashboard_view_grid}/>
						<span>Grid View</span></div></div>
					</div> 
					<div className="form-group">
						<label> Show Shortcut Icons  </label>
						<input onChange={this.handleInputChange} type="checkbox"  name="shortcut_checkbox" checked={this.state.shortcut_checked}/>
	                    {/* <span>Show</span> */}
					</div>
					{/* <div className="form-group admin-panel-btn">
						<label>Shortcut box shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shortcutBoxShadowDet" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this)} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div>  */}
				</div>
			</div> 
			
			{/* <div className="title">
				<h4>AI Sidebar Management</h4>
			</div> 

			<div className="form-row">			
				<div className="form-left">

					<div className="form-group">
						<label>Main AI Sidebar Collapsed Width: </label>
						<input type="number" className="form-control" name="mainAISidebarCollapsedWidth"  onChange={this.handleInputChange} value={this.state.mainAISidebarCollapsedWidth}/>
					</div>


                    <div className="form-group">
						<label>Main AI Sidebar Width: </label>
						<input type="text" className="form-control" name="mainAISidebarWidth"  onChange={this.handleInputChange} value={this.state.mainAISidebarWidth}/>
						
					</div>
				</div>
				<div className="form-right">
				<div className="form-group">
						<label>Main AI Sidebar Icon Width: </label>
						<input type="text" className="form-control" name="mainAISidebarIconWidth"  onChange={this.handleInputChange} value={this.state.mainAISidebarIconWidth}/>
						
					</div>
				</div>
			</div> */}
		   <div className="title">
				<h4>Stripe Configuration</h4>
		   </div> 
		   <div className="form-group">
				    <input onChange={this.handleInputChange} type="radio" name="settings_enable_live" checked={this.state.stripe_live_checked}/>
	                <span>Live</span>
	                 <input onChange={this.handleInputChange} type="radio"  name="settings_enable_sandbox" checked={this.state.stripe_sandbox_checked}/>
	                <span>SandBox</span>
            </div> 
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Public Key<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" className="form-control" name="settings_public_key" onChange={this.handleInputChange}  value={this.state.settings_public_key}/>
					<div className="errorsettings_public_key"></div>
				</div>

				<div className="form-group">
					<label>Product Key<span class="required" style={{ color: "red" }} > * </span>
:</label>
					<input type="text" className="form-control" name="settings_product_key" onChange={this.handleInputChange}  value={this.state.settings_product_key}/>
					<div className="errorsettings_product_key"></div>
					<span>Note : For Recurring payment(Monthly) the product key use.</span>
				</div>
					
			</div>	
			<div className="form-right">
				
				<div className="form-group">					
					<label>Secret Key<span class="required" style={{ color: "red" }} > * </span>
					:</label>
					<input type="password" className="form-control" name="settings_secret_key"  onChange={this.handleInputChange}  value={this.state.settings_secret_key} />
					<div className="errorsettings_secret_key"></div>
				</div>	
			</div>	
      	</div>		
		  {/* <div className="title">
				<h4>Shadow Management</h4>
			</div>
			<div className='form-row '>
				<div className='form-left'>
					
					 <div className="form-group admin-panel-btn">
						<label>Dashboard Grid Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="dashboardGridShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.dashboardGridShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'dashboardGridShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label>Shortcut Menu Shadow (Shortcut menu, AI screen textarea): </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="ShortcutMenuShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.ShortcutMenuShadow} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'ShortcutMenuShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label>Button Shadow (Large, Small): </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="ButtonShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.ButtonShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'ButtonShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label> Plugin Open Button Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="PluginOpenButtonShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.PluginOpenButtonShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'PluginOpenButtonShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					 <div className="form-group admin-panel-btn">
						<label> Dropdown Menu Shadow (Bell notification, Address dropdown): </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="DropdownShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.DropdownShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'DropdownShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label> Map Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="pluginMapShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.pluginMapShadow} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'pluginMapShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div>
						<div className="form-group admin-panel-btn">
						<label> Plugin Inset Left Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shadowPluginInsetLeft" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowPluginInsetLeft} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowPluginInsetLeft')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label> Plugin Inset Top Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shadowPluginInsetTop" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowPluginInsetTop} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowPluginInsetTop')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label>Left Sidebar Shadow (Side Menu): </label>
					    <div class="">
							<input type="text" name="shadowLeftSidebar" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowLeftSidebar} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowLeftSidebar')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					 <div className="form-group admin-panel-btn">
						<label> Result Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shadowResult" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowResult} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowResult')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 
					 <div className="form-group admin-panel-btn">
						<label> Input Box Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="InputBoxShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.InputBoxShadow} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'InputBoxShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
				</div>
				<div className='form-right'>
					<div className="form-group admin-panel-btn">
						<label>Textarea Shadow (Address field, Result): </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="TextareaShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.TextareaShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'TextareaShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					 <div className="form-group admin-panel-btn">
						<label>Dashboard List Shadow: </label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="DashboardListShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.DashboardListShadow} class="form-control"  style={{width: "85%"}} />
							<button type='button' onClick={this.boxShadowFunc.bind(this,'DashboardListShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					
					 <div className="form-group admin-panel-btn">
						<label>AI Sidebar Shadow:</label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="SidemenuShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.SidemenuShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'SidemenuShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					
					 <div className="form-group admin-panel-btn">
						<label> Plugin Inner Shadow: </label>
					    <div >
							<input type="text" name="shadowPluginInset" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowPluginInset} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowPluginInset')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					 <div className="form-group admin-panel-btn">
						<label> Lisiting Shadow: </label>
					    <div >
							<input type="text" name="lisitingShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.lisitingShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'lisitingShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					<div className="form-group admin-panel-btn">
						<label> AI Screen Textarea Shadow: </label>
					    <div >
							<input type="text" name="AIScreenTextareaShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.AIScreenTextareaShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'AIScreenTextareaShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
					
					 <div className="form-group admin-panel-btn">
						<label> Plugin Inset Right Shadow: </label>
					    <div >
							<input type="text" name="shadowPluginInsetRight" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowPluginInsetRight} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowPluginInsetRight')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					<div className="form-group admin-panel-btn">
						<label> Plugin Inset Bottom Shadow: </label>
					    <div >
							<input type="text" name="shadowPluginInsetBottom" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowPluginInsetBottom} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowPluginInsetBottom')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 
						
					<div className="form-group admin-panel-btn">
						<label>Right Sidebar Shadow (Chat window, Guest Payment Form):</label>
					    <div class="errorsettings_domain_title1">
							<input type="text" name="shadowRightSidebar" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.shadowRightSidebar} class="form-control"  style={{width: "85%"}} />							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'shadowRightSidebar')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
						
 					</div> 
					<div className="form-group admin-panel-btn">
						<label> Open Button Inner Shadow: </label>
					    <div >
							<input type="text" name="openButtonInnerShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.openButtonInnerShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'openButtonInnerShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					 <div className="form-group admin-panel-btn">
						<label> Table Shadow: </label>
					    <div >
							<input type="text" name="tableShadow" autocomplete="off" onChange={this.handleInputShadowChange} value={this.state.tableShadow} class="form-control"  style={{width: "85%"}} />
							
							<button type='button' onClick={this.boxShadowFunc.bind(this,'tableShadow')} style={{color: "white", padding: "14px", minWidth: "47px", height: "48px", backgroundColor: "rgb(5, 31, 58)", borderRadius: "0px 5px 5px 0px"}}><i><svg xmlns="http://www.w3.org/2000/svg" fill='#fff' viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i></button></div>
 					</div> 

					 
				</div>
			</div> */}
			
			{/* <div className="title">
				<h4>Radius Management</h4>
			</div>  */}
			{/* <div className="form-row">
				<div className="form-right">	
			 		<div className="form-group">
						<label>Dropdown Menu Radius <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="DropdownRadius" onChange={this.handleInputChange}  value={this.state.DropdownRadius}  />
						<div className="errorDropdownRadius"></div>
					</div>					
					<div className="form-group">
						<label>Map Radius </label>
						<input type="number" className="form-control" name="pluginMapRadius" onChange={this.handleInputChange}  value={this.state.pluginMapRadius}  />
						<div className="pluginMapRadius"></div>
					</div>
					<div className="form-group">
						<label>Textarea Radius </label>
						<input type="number" className="form-control" name="TextareaRadius" onChange={this.handleInputChange}  value={this.state.TextareaRadius}  />
						<div className="TextareaRadius"></div>
					</div>

					<div className="form-group">
						<label>LisitingRadius Radius</label>
						<input type="number" className="form-control" name="lisitingRadius" onChange={this.handleInputChange}  value={this.state.lisitingRadius}  />
						<div className="lisitingRadius"></div>
					</div>

				
				</div><div className="form-left">	
			 		<div className="form-group">
						<label>Plugin Radius <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="pluginRadius" onChange={this.handleInputChange}  value={this.state.pluginRadius}   />
						<div className="errorpluginRadius"></div>
					</div>
					<div className="form-group">
						<label>Input Box Radius </label>
						<input type="number" className="form-control" name="InputBoxRadius" onChange={this.handleInputChange}  value={this.state.InputBoxRadius}   />
						<div className="errorInputBoxRadius"></div>
					</div>

					<div className="form-group">
						<label>Plugin Open Button Radius</label>
						<input type="number" className="form-control" name="pluginOpenButtonRadius" onChange={this.handleInputChange}  value={this.state.pluginOpenButtonRadius}   />
						<div className="errorpluginOpenButtonRadius"></div>
					</div>
				</div>
			</div>	
		  	<div className="title">
				<h4>Font Management</h4>
			</div> 
			<div className="form-row">		
				<div className="form-left">
					<div className="form-group">
						<label>Line Height <span class="required" style={{ color: "red" }} > * </span></label>
						<input type="number" className="form-control" name="lineheight" onChange={this.handleInputChange}  value={this.state.lineheight}/>
						<div className="errorlineheight"></div>
					</div>
				
				</div>	
			</div> */}

			{/* {this.addMoreFunc()}	  */}
			<div className="title">
				<h4>Theme Management</h4>
			</div> 
			
			<div className="form-row">		
				<div className="form-left">
					<div className="default-font">
						<div className="form-group">
							<label>Theme :</label>
							<Select 
								options={this.state.themeData}  
								value={selTheme?selTheme:{ value: '0', label: 'Select Theme' }}
								onChange={this.handleChangeTheme}
								placeholder="Select theme"
							/>
							<div className="errortheme"></div>
						</div>
					</div> 
				</div> 
			</div>		 
			<div className="btn-group export">	
				
                <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                <span className="load-data">Loading</span> 
                                } Submit
			    </button>	
			</div>
				<div className=" template-action template-popup" >
					<a className='pet-close' onClick={this.closeTemplatePopup} href="javascript:void(0);">x</a>
					<p>{this.state.selected_template.value ==1 ? <img src={template1} width={250} height={250} />:''}
					{this.state.selected_template.value ==2 ? <img src={template2} width={250} height={250} />:''}
					{this.state.selected_template.value ==3 ? <img src={template3} width={250} height={250} />:''}</p>
				</div>

			</div>
			</form>
			</div>	
		</div>	
	</div>
		 	
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
	settings: state.settings,
	updatesetting: state.updatesetting,
	fontname : state.fontname
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
	   getSettingData: (formPayload) =>{
       dispatch({ type: GET_SETTINGDATA, formPayload});
       },
       getFontName: () => {
        dispatch({ type: GET_FONTNAME });
      },
      getUpdateSetting: (formPayload) => {
      dispatch({ type: GET_UPDATESETTING, formPayload });
   	  }
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(Setting));